/* eslint-disable */
/* Autogenerated from Payloads::Admins::GetManyType */
export type AdminsGetManyTypePayload = Array<AdminsGetManyTypeOnePayload>;

export type AdminsGetManyTypeOnePayload = {
  id: number;
  firstName: string | null;
  lastName: string | null;
  role: string | null;
  remark: string | null;
  imageUrl: string | null;
  displayOrder: number | null;
  isSelected: boolean;
};

/* Autogenerated from Payloads::Usersite::Plans::ScheduleManyType */
export type UsersitePlansScheduleManyTypePayload =
  Array<UsersitePlansScheduleManyTypeOnePayload>;

export type UsersitePlansScheduleManyTypeOnePayload = {
  isPrimary: boolean;
  description: string;
  minStartsAt: string;
  maxEndsAt: string;
  totalWorkingMinutes: number;
};

/* Autogenerated from Inputs::Admins::Plans::AdminManyType */
export type AdminsPlansAdminManyTypeInput =
  Array<AdminsPlansAdminManyTypeOneInput>;

export type AdminsPlansAdminManyTypeOneInput = {
  id?: number;
  lastName: string;
  firstName: string;
  remark: string | null;
  role: string | null;
  imageBlob: string | null;
  displayOrder: number | null;
};

/* Autogenerated from Inputs::Admins::Plans::AdminsPlanManyType */
export type AdminsPlansAdminsPlanManyTypeInput =
  Array<AdminsPlansAdminsPlanManyTypeOneInput>;

export type AdminsPlansAdminsPlanManyTypeOneInput = {
  adminId: number;
  displayOrder: number | null;
  Destroy: boolean | null;
};

/* Autogenerated from Payloads::V1::Admins::PlanAtmosphereSliders::GetManyType */
export type V1AdminsPlanAtmosphereSlidersGetManyTypePayload =
  Array<V1AdminsPlanAtmosphereSlidersGetManyTypeOnePayload>;

export type V1AdminsPlanAtmosphereSlidersGetManyTypeOnePayload = {
  atmosphereSliders: V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayload;
  sliderKeys: Array<string>;
};

/* Autogenerated from Payloads::V1::Usersite::UserExpressions::GetOneType */
export type V1UsersiteUserExpressionsGetOneTypePayload =
  Array<V1UsersiteUserExpressionsGetOneTypeOnePayload>;

export type V1UsersiteUserExpressionsGetOneTypeOnePayload = {
  id: number;
  word: string;
};

/* Autogenerated from Payloads::V1::Usersite::UserExpressions::GetManyType */
export type V1UsersiteUserExpressionsGetManyTypePayload =
  Array<V1UsersiteUserExpressionsGetManyTypeOnePayload>;

export type V1UsersiteUserExpressionsGetManyTypeOnePayload = {
  id: number;
  word: string;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantWorkingTimeSectionRequests::GetManyType */
export type V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayload =
  Array<V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypeOnePayload>;

export type V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypeOnePayload =
  {
    id: number;
    startsAt: string;
    endsAt: string;
    isBreak: boolean;
    sectionId: number;
    action: V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayloadActionType;
  };

export const V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayloadAction =
  {
    CREATE: 'create',
    UPDATE: 'update',
    DESTROY: 'destroy',
  };

export type V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayloadActionType =
  typeof V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayloadAction[keyof typeof V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayloadAction];

/* Autogenerated from Payloads::V1::Usersite::Plans::MealManyType */
export type V1UsersitePlansMealManyTypePayload =
  Array<V1UsersitePlansMealManyTypeOnePayload>;

export type V1UsersitePlansMealManyTypeOnePayload = {
  id: number;
  timing: V1UsersitePlansMealManyTypePayloadTimingType;
  payer: V1UsersitePlansMealManyTypePayloadPayerType | null;
  kind: V1UsersitePlansMealManyTypePayloadKindType | null;
  description: string | null;
  timingText: string;
  payerText: string | null;
  kindText: string | null;
};

export const V1UsersitePlansMealManyTypePayloadTiming = {
  MORNING: 'morning',
  NOON: 'noon',
  EVENING: 'evening',
};

export type V1UsersitePlansMealManyTypePayloadTimingType =
  typeof V1UsersitePlansMealManyTypePayloadTiming[keyof typeof V1UsersitePlansMealManyTypePayloadTiming];

export const V1UsersitePlansMealManyTypePayloadPayer = {
  BUSINESS: 'business',
  PARTICIPANT: 'participant',
};

export type V1UsersitePlansMealManyTypePayloadPayerType =
  typeof V1UsersitePlansMealManyTypePayloadPayer[keyof typeof V1UsersitePlansMealManyTypePayloadPayer];

export const V1UsersitePlansMealManyTypePayloadKind = {
  LUNCH_BOX: 'lunch_box',
  STAFF_MEAL: 'staff_meal',
  SELF_CATERING: 'self_catering',
  SELF_CATERING_INGREDIENTS_PROVIDED: 'self_catering_ingredients_provided',
  DINING: 'dining',
  RESTAURANT: 'restaurant',
  MARKET: 'market',
  HOME_COOKED: 'home_cooked',
  OTHER: 'other',
};

export type V1UsersitePlansMealManyTypePayloadKindType =
  typeof V1UsersitePlansMealManyTypePayloadKind[keyof typeof V1UsersitePlansMealManyTypePayloadKind];

/* Autogenerated from Payloads::V1::Usersite::Plans::FacilityImageManyType */
export type V1UsersitePlansFacilityImageManyTypePayload =
  Array<V1UsersitePlansFacilityImageManyTypeOnePayload>;

export type V1UsersitePlansFacilityImageManyTypeOnePayload = {
  imageUrl: string;
  displayOrder: number;
  kind: V1UsersitePlansFacilityImageManyTypePayloadKindType;
  description: string;
  kindText: string;
};

export const V1UsersitePlansFacilityImageManyTypePayloadKind = {
  BEDROOM_MALE: 'bedroom_male',
  BEDROOM_FEMALE: 'bedroom_female',
  BEDROOM_COMMON: 'bedroom_common',
  BATHROOM: 'bathroom',
  APPEARANCE: 'appearance',
  OTHER: 'other',
};

export type V1UsersitePlansFacilityImageManyTypePayloadKindType =
  typeof V1UsersitePlansFacilityImageManyTypePayloadKind[keyof typeof V1UsersitePlansFacilityImageManyTypePayloadKind];

/* Autogenerated from Payloads::V1::Usersite::Plans::AtmosphereSliderManyType */
export type V1UsersitePlansAtmosphereSliderManyTypePayload =
  Array<V1UsersitePlansAtmosphereSliderManyTypeOnePayload>;

export type V1UsersitePlansAtmosphereSliderManyTypeOnePayload = {
  id: number;
  selectNumber: number;
  isMultipleSelection: boolean;
  values: Array<string>;
  kind: V1UsersitePlansAtmosphereSliderManyTypePayloadKindType;
};

export const V1UsersitePlansAtmosphereSliderManyTypePayloadKind = {
  EXPECTATION: 'expectation',
  POWER_JOB: 'power_job',
  STAFF_HOMETOWN: 'staff_hometown',
  RELATIONSHIP_NO_BUSINESS: 'relationship_no_business',
  AGE_GROUP: 'age_group',
  CONDITION: 'condition',
  NATURE: 'nature',
  HOTEL: 'hotel',
  RELATIONSHIP_BUSINESS: 'relationship_business',
  GENDER: 'gender',
};

export type V1UsersitePlansAtmosphereSliderManyTypePayloadKindType =
  typeof V1UsersitePlansAtmosphereSliderManyTypePayloadKind[keyof typeof V1UsersitePlansAtmosphereSliderManyTypePayloadKind];

/* Autogenerated from Payloads::V1::Usersite::Plans::SkillCategoryManyType */
export type V1UsersitePlansSkillCategoryManyTypePayload =
  Array<V1UsersitePlansSkillCategoryManyTypeOnePayload>;

export type V1UsersitePlansSkillCategoryManyTypeOnePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::V1::Common::Countries::GetManyType */
export type V1CommonCountriesGetManyTypePayload =
  Array<V1CommonCountriesGetManyTypeOnePayload>;

export type V1CommonCountriesGetManyTypeOnePayload = {
  id: number;
  enName: string;
  name: string;
};

/* Autogenerated from Payloads::V1::Usersite::Experiences::ManyType */
export type V1UsersiteExperiencesManyTypePayload =
  Array<V1UsersiteExperiencesManyTypeOnePayload>;

export type V1UsersiteExperiencesManyTypeOnePayload = {
  id: number;
  organization: string;
  role: string;
  startDate: string;
  endDate: string | null;
  description: string;
  industry: V1CommonIndustriesGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Experiences::GetOneType */
export type V1UsersiteExperiencesGetOneTypePayload =
  Array<V1UsersiteExperiencesGetOneTypeOnePayload>;

export type V1UsersiteExperiencesGetOneTypeOnePayload = {
  id: number;
  organization: string;
  role: string;
  startDate: string;
  endDate: string | null;
  description: string;
  industry: V1CommonIndustriesGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantWorkingTimeSections::GetManyType */
export type V1UsersiteParticipantWorkingTimeSectionsGetManyTypePayload =
  Array<V1UsersiteParticipantWorkingTimeSectionsGetManyTypeOnePayload>;

export type V1UsersiteParticipantWorkingTimeSectionsGetManyTypeOnePayload = {
  id: number;
  startsAt: string;
  endsAt: string;
  isBreak: boolean | null;
  signature: V1UsersiteParticipantWorkingTimeSignaturesGetOneTypePayload;
  qrHistories: V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantWorkingTimeQrHistories::GetManyType */
export type V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayload =
  Array<V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypeOnePayload>;

export type V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypeOnePayload = {
  id: number;
  latitude: string;
  longitude: string;
  action: V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayloadActionType;
};

export const V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayloadAction =
  {
    CHECKIN: 'checkin',
    CHECKOUT: 'checkout',
  };

export type V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayloadActionType =
  typeof V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayloadAction[keyof typeof V1UsersiteParticipantWorkingTimeQrHistoriesGetManyTypePayloadAction];

/* Autogenerated from Payloads::V1::Usersite::Educations::GetOneType */
export type V1UsersiteEducationsGetOneTypePayload =
  Array<V1UsersiteEducationsGetOneTypeOnePayload>;

export type V1UsersiteEducationsGetOneTypeOnePayload = {
  id: number;
  school: string;
  degree: string | null;
  faculty: string;
  department: string | null;
  startDate: string;
  endDate: string | null;
  description: string;
};

/* Autogenerated from Payloads::V1::Common::Interests::GetManyType */
export type V1CommonInterestsGetManyTypePayload =
  Array<V1CommonInterestsGetManyTypeOnePayload>;

export type V1CommonInterestsGetManyTypeOnePayload = {
  id: number;
  name: string;
  division: number;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::GetType */
export type V1UsersiteParticipantDailyWorkingTimesGetTypePayload =
  Array<V1UsersiteParticipantDailyWorkingTimesGetTypeOnePayload>;

export type V1UsersiteParticipantDailyWorkingTimesGetTypeOnePayload = {
  participant: V1UsersiteParticipantDailyWorkingTimesParticipantTypePayload;
  dailyWorkingTimes: V1UsersiteParticipantDailyWorkingTimesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::ParticipantType */
export type V1UsersiteParticipantDailyWorkingTimesParticipantTypePayload =
  Array<V1UsersiteParticipantDailyWorkingTimesParticipantTypeOnePayload>;

export type V1UsersiteParticipantDailyWorkingTimesParticipantTypeOnePayload = {
  id: number;
  startsAt: string;
  finishesAt: string;
  dayStartingHour: number;
  dayStartingMin: number;
  isEmploymentEnabled: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::GetManyType */
export type V1UsersiteParticipantDailyWorkingTimesGetManyTypePayload =
  Array<V1UsersiteParticipantDailyWorkingTimesGetManyTypeOnePayload>;

export type V1UsersiteParticipantDailyWorkingTimesGetManyTypeOnePayload = {
  id: number;
  workedOn: string;
  isHoliday: boolean;
  regularMinutes: number;
  overtimeMinutes: number;
  nightMinutes: number;
  holidayMinutes: number;
  overtimeNightMinutes: number;
  holidayNightMinutes: number;
  totalOutsourcingMinutes: number;
  availableSections: V1UsersiteParticipantWorkingTimeSectionsGetManyTypePayload;
  displaySections: V1UsersiteParticipantWorkingTimeSectionsGetManyTypePayload;
  latestRequest: V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayload | null;
  pendingRequest: V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayload | null;
};

/* Autogenerated from Payloads::V1::Usersite::Educations::ManyType */
export type V1UsersiteEducationsManyTypePayload =
  Array<V1UsersiteEducationsManyTypeOnePayload>;

export type V1UsersiteEducationsManyTypeOnePayload = {
  id: number;
  school: string;
  degree: string | null;
  faculty: string;
  department: string | null;
  startDate: string;
  endDate: string | null;
  description: string;
};

/* Autogenerated from Payloads::V1::Common::BankBranches::GetManyType */
export type V1CommonBankBranchesGetManyTypePayload =
  Array<V1CommonBankBranchesGetManyTypeOnePayload>;

export type V1CommonBankBranchesGetManyTypeOnePayload = {
  id: number;
  code: string;
  hira: string;
  kana: string;
  name: string;
  roma: string;
};

/* Autogenerated from Payloads::V1::Common::PersonalSkills::GetManyType */
export type V1CommonPersonalSkillsGetManyTypePayload =
  Array<V1CommonPersonalSkillsGetManyTypeOnePayload>;

export type V1CommonPersonalSkillsGetManyTypeOnePayload = {
  id: number;
  name: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Banks::GetManyType */
export type V1CommonBanksGetManyTypePayload =
  Array<V1CommonBanksGetManyTypeOnePayload>;

export type V1CommonBanksGetManyTypeOnePayload = {
  id: number;
  code: string;
  hira: string;
  kana: string;
  name: string;
  roma: string;
};

/* Autogenerated from Payloads::V1::Common::Qualifications::TertiaryManyType */
export type V1CommonQualificationsTertiaryManyTypePayload =
  Array<V1CommonQualificationsTertiaryManyTypeOnePayload>;

export type V1CommonQualificationsTertiaryManyTypeOnePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Qualifications::PrimaryManyType */
export type V1CommonQualificationsPrimaryManyTypePayload =
  Array<V1CommonQualificationsPrimaryManyTypeOnePayload>;

export type V1CommonQualificationsPrimaryManyTypeOnePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
  tertiaryItems: V1CommonQualificationsTertiaryManyTypePayload;
};

/* Autogenerated from Inputs::V1::Usersite::CharacteristicsUsers::UpdateManyType */
export type V1UsersiteCharacteristicsUsersUpdateManyTypeInput =
  Array<V1UsersiteCharacteristicsUsersUpdateManyTypeOneInput>;

export type V1UsersiteCharacteristicsUsersUpdateManyTypeOneInput = {
  characteristicId: number;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::UserExpressions::UpdateManyType */
export type V1UsersiteUserExpressionsUpdateManyTypeInput =
  Array<V1UsersiteUserExpressionsUpdateManyTypeOneInput>;

export type V1UsersiteUserExpressionsUpdateManyTypeOneInput = {
  id?: string;
  word: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::UsersAllergies::UpdateManyType */
export type V1UsersiteUsersAllergiesUpdateManyTypeInput =
  Array<V1UsersiteUsersAllergiesUpdateManyTypeOneInput>;

export type V1UsersiteUsersAllergiesUpdateManyTypeOneInput = {
  allergyId?: number;
  other?: string | null;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::PersonalSkillsUsers::UpdateManyType */
export type V1UsersitePersonalSkillsUsersUpdateManyTypeInput =
  Array<V1UsersitePersonalSkillsUsersUpdateManyTypeOneInput>;

export type V1UsersitePersonalSkillsUsersUpdateManyTypeOneInput = {
  personalSkillId: number;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::UserQualifications::UpdateManyType */
export type V1UsersiteUserQualificationsUpdateManyTypeInput =
  Array<V1UsersiteUserQualificationsUpdateManyTypeOneInput>;

export type V1UsersiteUserQualificationsUpdateManyTypeOneInput = {
  id?: number;
  qualificationId?: number;
  name?: string;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantWorkingTimeSections::ManyType */
export type V1UsersiteParticipantWorkingTimeSectionsManyTypeInput =
  Array<V1UsersiteParticipantWorkingTimeSectionsManyTypeOneInput>;

export type V1UsersiteParticipantWorkingTimeSectionsManyTypeOneInput = {
  id: number;
  startsAt: string;
  endsAt: string;
  isBreak: boolean;
  isDestroy: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::Tutorials::UpdateFifthType */
export type V1UsersiteTutorialsUpdateFifthTypeInput =
  Array<V1UsersiteTutorialsUpdateFifthTypeOneInput>;

export type V1UsersiteTutorialsUpdateFifthTypeOneInput = {
  businessId: number;
  destroy: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::ManyType */
export type V1UsersiteParticipantDailyWorkingTimesManyTypeInput =
  Array<V1UsersiteParticipantDailyWorkingTimesManyTypeOneInput>;

export type V1UsersiteParticipantDailyWorkingTimesManyTypeOneInput = {
  workedOn: string;
  sections: V1UsersiteParticipantWorkingTimeSectionsManyTypeInput;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetManyType */
export type V1UsersiteBusinessesGetManyTypePayload = {
  page: number;
  hasMore: boolean;
  title: string | null;
  results: Array<V1UsersiteBusinessesGetOneCardTypePayload>;
};

/* Autogenerated from Payloads::ErrorType */
export type ErrorTypePayload = {
  code: number;
  errorMessage: string;
  errorType: string;
  errors: Array<ErrorTypeGetOneTypePayload>;
};

/* Autogenerated from Payloads::ErrorType::GetOneType */
export type ErrorTypeGetOneTypePayload = {
  key?: string;
  errorMessage: string;
  errorType: string;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::ErrorType */
export type V1UsersiteParticipantDailyWorkingTimesErrorTypePayload = {
  key?: string;
  errorMessage: string;
  errorType: string;
  errors: Array<V1UsersiteParticipantDailyWorkingTimesChildErrorTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::ChildErrorType */
export type V1UsersiteParticipantDailyWorkingTimesChildErrorTypePayload = {
  key?: string;
  errorMessage: string;
  errorType: string;
  workedOn?: string;
};

/* Autogenerated from Payloads::SuccessType */
export type SuccessTypePayload = {
  message: string;
};

/* Autogenerated from Payloads::Usersite::Plans::GetRegionType */
export type UsersitePlansGetRegionTypePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::Usersite::Plans::GetSearchChoiceType */
export type UsersitePlansGetSearchChoiceTypePayload = {
  tags: Array<UsersitePlansGetTagTypePayload>;
  regions: Array<UsersitePlansGetRegionTypePayload>;
};

/* Autogenerated from Payloads::Usersite::Plans::GetTagType */
export type UsersitePlansGetTagTypePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::Usersite::Plans::GetManyPlanReviewsType */
export type UsersitePlansGetManyPlanReviewsTypePayload = {
  averageRating: number;
  totalCount: number;
};

/* Autogenerated from Payloads::Usersite::Plans::GetManyPlansType */
export type UsersitePlansGetManyPlansTypePayload = {
  id: number;
  title: string;
  city: string;
  cityKana: string;
  favoriteCount: number;
  isFavorite: boolean;
  thumbnailUrl: string;
  regionName: string;
  review: UsersitePlansGetManyPlanReviewsTypePayload | null;
  active: boolean;
  statusText: string;
  futureOpen: boolean;
  tagName: string | null;
  url: string;
};

/* Autogenerated from Payloads::Usersite::Plans::GetManyType */
export type UsersitePlansGetManyTypePayload = {
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  acceptingPlans: Array<UsersitePlansGetManyPlansTypePayload>;
  title: string | null;
  count: number;
  isAuthenticated: boolean;
  tags?: Array<UsersitePlansGetTagTypePayload>;
  regions?: Array<UsersitePlansGetRegionTypePayload>;
};

/* Autogenerated from Payloads::Usersite::Plans::GetFavoriteCountType */
export type UsersitePlansGetFavoriteCountTypePayload = {
  planId: number;
  favoriteCount: number;
};

/* Autogenerated from Inputs::Admins::Businesses::StatusType */
export type AdminsBusinessesStatusTypeInput = {
  status: AdminsBusinessesStatusTypeInputStatusType;
  canCreateAdmin?: boolean | null;
};

export const AdminsBusinessesStatusTypeInputStatus = {
  PENDING: 'pending',
  AGREED: 'agreed',
  REJECTED: 'rejected',
  DELETED: 'deleted',
};

export type AdminsBusinessesStatusTypeInputStatusType =
  typeof AdminsBusinessesStatusTypeInputStatus[keyof typeof AdminsBusinessesStatusTypeInputStatus];

/* Autogenerated from Inputs::Admins::Plans::UpdateAdminsType */
export type AdminsPlansUpdateAdminsTypeInput = {
  admins: AdminsPlansAdminManyTypeInput;
  adminsPlans: AdminsPlansAdminsPlanManyTypeInput;
};

/* Autogenerated from Inputs::Admins::SurveyAggregates::GetCsvDownloadType */
export type AdminsSurveyAggregatesGetCsvDownloadTypeInput = {
  startDate?: string;
  endDate?: string;
};

/* Autogenerated from Inputs::Usersite::Plans::DisfavorType */
export type UsersitePlansDisfavorTypeInput = {
  planId: number;
};

/* Autogenerated from Inputs::Usersite::Plans::FavorType */
export type UsersitePlansFavorTypeInput = {
  planId: number;
};

/* Autogenerated from Inputs::Usersite::Plans::FavoritePlansType */
export type UsersitePlansFavoritePlansTypeInput = {
  page: number;
};

/* Autogenerated from Inputs::Usersite::Plans::IndexType */
export type UsersitePlansIndexTypeInput = {
  feature?: string;
  type?: string;
  year?: number;
  month?: number;
};

/* Autogenerated from Inputs::Usersite::PasswordResets::UpdateType */
export type UsersitePasswordResetsUpdateTypeInput = {
  token: string;
  password: string;
  passwordConfirmation: string;
};

/* Autogenerated from Inputs::Usersite::PasswordResets::ResetType */
export type UsersitePasswordResetsResetTypeInput = {
  signInEmail: string;
};

/* Autogenerated from Payloads::V1::Admins::PlanAtmosphereSliders::GetManyAtmosphereSliderType */
export type V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayload = {
  id: number;
  name: string;
  selectNumber: number;
  isMultipleSelection: boolean;
  values: Array<string>;
  kind: V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayloadKindType;
};

export const V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayloadKind =
  {
    EXPECTATION: 'expectation',
    POWER_JOB: 'power_job',
    STAFF_HOMETOWN: 'staff_hometown',
    RELATIONSHIP_NO_BUSINESS: 'relationship_no_business',
    AGE_GROUP: 'age_group',
    CONDITION: 'condition',
    NATURE: 'nature',
    HOTEL: 'hotel',
    RELATIONSHIP_BUSINESS: 'relationship_business',
    GENDER: 'gender',
  };

export type V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayloadKindType =
  typeof V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayloadKind[keyof typeof V1AdminsPlanAtmosphereSlidersGetManyAtmosphereSliderTypePayloadKind];

/* Autogenerated from Payloads::V1::Usersite::Tokens::AuthenticateType */
export type V1UsersiteTokensAuthenticateTypePayload = {
  accessToken: string;
  expiresIn: number;
  expiresAt: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  refreshTokenExpiresAt: number;
};

/* Autogenerated from Payloads::V1::Usersite::Token::UseRefreshTokenType */
export type V1UsersiteTokenUseRefreshTokenTypePayload = {
  accessToken: string;
  expiresIn: number;
  expiresAt: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  refreshTokenExpiresAt: number;
};

/* Autogenerated from Payloads::V1::Usersite::Home::GetMobileType */
export type V1UsersiteHomeGetMobileTypePayload = {
  topTab: V1UsersiteHomeGetTopTabTypePayload;
  otherTabs: Array<V1UsersiteHomeGetOneTabTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Home::GetTopTabType */
export type V1UsersiteHomeGetTopTabTypePayload = {
  name: string;
  planFeatures: Array<V1UsersitePlanFeaturesGetOneTypePayload>;
  contents: Array<V1UsersiteHomeGetTopContentTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::PlanFeatures::GetOneType */
export type V1UsersitePlanFeaturesGetOneTypePayload = {
  id: number;
  name: string;
  imageUrl: string;
};

/* Autogenerated from Payloads::V1::Usersite::Home::GetTopContentType */
export type V1UsersiteHomeGetTopContentTypePayload = {
  name: string;
  type: V1UsersiteHomeGetTopContentTypePayloadTypeType;
  plans?: Array<UsersitePlansGetManyPlansTypePayload>;
  businesses?: Array<V1UsersiteBusinessesGetOneCardTypePayload>;
};

export const V1UsersiteHomeGetTopContentTypePayloadType = {
  PLAN: 'plan',
  BUSINESS: 'business',
};

export type V1UsersiteHomeGetTopContentTypePayloadTypeType =
  typeof V1UsersiteHomeGetTopContentTypePayloadType[keyof typeof V1UsersiteHomeGetTopContentTypePayloadType];

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetOneCardType */
export type V1UsersiteBusinessesGetOneCardTypePayload = {
  id: number;
  displayName: string;
  title: string;
  thumbnailUrl: string | null;
  subcategoryName: string;
  isRecent: boolean;
  isFollowing: boolean;
  address: V1UsersiteBusinessAddressesGetOneTypePayload | null;
  reviewSummary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
};

/* Autogenerated from Payloads::V1::Usersite::BusinessAddresses::GetOneType */
export type V1UsersiteBusinessAddressesGetOneTypePayload = {
  city: string | null;
  cityKana: string | null;
  streetAddress: string | null;
  building: string | null;
  zip: string | null;
  region: V1CommonRegionsGetOneTypePayload | null;
};

/* Autogenerated from Payloads::V1::Common::Regions::GetOneType */
export type V1CommonRegionsGetOneTypePayload = {
  id: number;
  countryId: number;
  areaId: number;
  enName: string;
  name: string;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantReviewSummaries::GetOneType */
export type V1UsersiteParticipantReviewSummariesGetOneTypePayload = {
  averageRating: number;
  reviewsCount: number;
  reviewsLimit?: number | null;
};

/* Autogenerated from Payloads::V1::Usersite::Home::GetOneTabType */
export type V1UsersiteHomeGetOneTabTypePayload = {
  name: string;
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Participants::WithdrawOneType */
export type V1UsersiteParticipantsWithdrawOneTypePayload = {
  id: number;
  term: V1UsersitePlanTermsWithdrawOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::PlanTerms::WithdrawOneType */
export type V1UsersitePlanTermsWithdrawOneTypePayload = {
  id: number;
  plan: V1UsersitePlansWithdrawOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::WithdrawOneType */
export type V1UsersitePlansWithdrawOneTypePayload = {
  id: number;
  title: string;
};

/* Autogenerated from Payloads::V1::Usersite::Participants::GetOnePaymentType */
export type V1UsersiteParticipantsGetOnePaymentTypePayload = {
  id: number;
  applicantId: number;
  startsAt: string;
  finishesAt: string;
  isEmploymentEnabled: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::PlanTermWorkingTimes::GetOneType */
export type V1UsersitePlanTermWorkingTimesGetOneTypePayload = {
  startTime: string;
  endTime: string;
  task: string;
  startTimeText: string;
  endTimeText: string;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::DestroyFollowType */
export type V1UsersiteBusinessesDestroyFollowTypePayload = {
  message: string;
  followerCount: number;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::BaseGetType */
export type V1UsersiteBusinessesBaseGetTypePayload = {
  id: number;
  name: string;
  homepage: string | null;
  logoUrl: string | null;
  address: V1UsersiteBusinessAddressesGetOneTypePayload | null;
  areaAttractions: Array<V1UsersiteBusinessAreaAttractionsGetOneTypePayload>;
  reviewSummary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetOneType */
export type V1UsersiteBusinessesGetOneTypePayload = {
  id: number;
  name: string;
  homepage: string | null;
  logoUrl: string | null;
  address: V1UsersiteBusinessAddressesGetOneTypePayload | null;
  areaAttractions: Array<V1UsersiteBusinessAreaAttractionsGetOneTypePayload>;
  reviewSummary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
  displayName: string;
  url: string;
  introduction: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetOnePlanTopType */
export type V1UsersiteBusinessesGetOnePlanTopTypePayload = {
  id: number;
  name: string;
  homepage: string | null;
  logoUrl: string | null;
  address: V1UsersiteBusinessAddressesGetOneTypePayload | null;
  areaAttractions: Array<V1UsersiteBusinessAreaAttractionsGetOneTypePayload>;
  reviewSummary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
  displayName: string;
  url: string;
  introduction: string | null;
  features: Array<string>;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetShowType */
export type V1UsersiteBusinessesGetShowTypePayload = {
  id: number;
  name: string;
  homepage: string | null;
  logoUrl: string | null;
  address: V1UsersiteBusinessAddressesGetOneTypePayload | null;
  areaAttractions: Array<V1UsersiteBusinessAreaAttractionsGetOneTypePayload>;
  reviewSummary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
  title: string;
  displayName: string;
  introduction: string;
  backgroundUrl: string;
  isFollowing: boolean;
  images: Array<V1UsersiteBusinessImagesGetOneTypePayload>;
  minds: Array<V1UsersiteBusinessMindsGetOneTypePayload>;
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  users: Array<V1UsersiteUsersGetOnePlanTypePayload>;
  tip: V1CommonTipsGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::BusinessAreaAttractions::GetOneType */
export type V1UsersiteBusinessAreaAttractionsGetOneTypePayload = {
  imageUrl: string;
  description: string;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetManyReviewsType */
export type V1UsersiteBusinessesGetManyReviewsTypePayload = {
  summary: V1UsersiteParticipantReviewSummariesGetOneTypePayload | null;
  sectionSummaries?: Array<V1UsersiteParticipantReviewSummariesGetOneSectionSummaryTypePayload> | null;
  reviews: Array<V1UsersiteParticipantReviewsGetOneTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantReviewSummaries::GetOneSectionSummaryType */
export type V1UsersiteParticipantReviewSummariesGetOneSectionSummaryTypePayload =
  {
    name: string;
    color: string | null;
    averageRating: number;
    optionSummaries: Array<V1UsersiteParticipantReviewSummariesGetManyOptionSummariesTypePayload>;
  };

/* Autogenerated from Payloads::V1::Usersite::ParticipantReviewSummaries::GetManyOptionSummariesType */
export type V1UsersiteParticipantReviewSummariesGetManyOptionSummariesTypePayload =
  {
    name: string;
    displayOrder: number | null;
    averageRating: number;
  };

/* Autogenerated from Payloads::V1::Usersite::ParticipantReviews::GetOneType */
export type V1UsersiteParticipantReviewsGetOneTypePayload = {
  message: string;
  rating: number;
  sexText: number;
  truncatedAgeText: number;
  startsAt: string;
  online: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::GetOnePaymentType */
export type V1UsersiteBusinessesGetOnePaymentTypePayload = {
  id: number;
  name: string;
  displayName: string;
};

/* Autogenerated from Payloads::V1::Usersite::Businesses::UpdateFollowType */
export type V1UsersiteBusinessesUpdateFollowTypePayload = {
  message: string;
  followerCount: number;
};

/* Autogenerated from Payloads::V1::Usersite::BusinessImages::GetOneType */
export type V1UsersiteBusinessImagesGetOneTypePayload = {
  id: number;
  imageUrl: string;
};

/* Autogenerated from Payloads::V1::Usersite::BusinessMinds::GetOneType */
export type V1UsersiteBusinessMindsGetOneTypePayload = {
  id: number;
  title: string;
  description: string;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetOnePlanType */
export type V1UsersiteUsersGetOnePlanTypePayload = {
  id: number;
  firstName: string;
  lastName: string;
  role: string | null;
  remark: string | null;
  imageUrl: string | null;
};

/* Autogenerated from Payloads::V1::Common::Tips::GetOneType */
export type V1CommonTipsGetOneTypePayload = {
  canShow: boolean;
  message: string;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::GetMeType */
export type V1UsersitePlanRoomsGetMeTypePayload = {
  token: string;
  imageUrl: string;
  name: string;
  customToken: string;
  type: string;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::GetType */
export type V1UsersitePlanRoomsGetTypePayload = {
  page: number;
  hasMore: boolean;
  me: V1UsersitePlanRoomsGetMeTypePayload;
  results: Array<V1UsersitePlanRoomsGetManyTypePayload>;
  tip: V1CommonTipsGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::GetManyType */
export type V1UsersitePlanRoomsGetManyTypePayload = {
  token: string;
  isClosed: boolean;
  isRestricted: boolean;
  isContactPhoneDisplayed: boolean;
  emergencyContactPhone: string;
  dates: Array<V1UsersitePlanRoomsDateTypePayload>;
  members: Array<V1UsersitePlanRoomsMemberTypePayload>;
  plan: UsersitePlansGetManyPlansTypePayload;
  business: V1UsersiteBusinessesGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::DateType */
export type V1UsersitePlanRoomsDateTypePayload = {
  id: number;
  startDate: string;
  endDate: string;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::MemberType */
export type V1UsersitePlanRoomsMemberTypePayload = {
  token: string;
  imageUrl: string;
  name: string;
  type: string;
};

/* Autogenerated from Payloads::V1::Usersite::PlanRooms::ShowType */
export type V1UsersitePlanRoomsShowTypePayload = {
  me: V1UsersitePlanRoomsGetMeTypePayload;
  results: V1UsersitePlanRoomsGetManyTypePayload;
  tip: V1CommonTipsGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Withdraws::CreateOneType */
export type V1UsersiteWithdrawsCreateOneTypePayload = {
  result: boolean;
  surveyUrl: string;
  waitingApprovalApplicants: Array<V1UsersiteApplicantsWithdrawOneTypePayload>;
  ongoingParticipants: Array<V1UsersiteParticipantsWithdrawOneTypePayload>;
  waitingPaymentParticipants: Array<V1UsersiteParticipantsWithdrawOneTypePayload>;
  reviewNotSubmittedParticipants: Array<V1UsersiteParticipantsWithdrawOneTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Applicants::WithdrawOneType */
export type V1UsersiteApplicantsWithdrawOneTypePayload = {
  id: number;
  term: V1UsersitePlanTermsWithdrawOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Withdraws::GetOneType */
export type V1UsersiteWithdrawsGetOneTypePayload = {
  survey: V1CommonSurveysGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Common::Surveys::GetOneType */
export type V1CommonSurveysGetOneTypePayload = {
  id: number;
  title: string;
  description: string;
  sections: Array<V1CommonSurveySectionsGetOneTypePayload>;
};

/* Autogenerated from Payloads::V1::Common::SurveySections::GetOneType */
export type V1CommonSurveySectionsGetOneTypePayload = {
  id: number;
  question: string;
  allowRating: boolean;
  minRating: number | null;
  maxRating: number | null;
  minRatingLabel: string | null;
  maxRatingLabel: string | null;
  skipLabel: string | null;
  maxChoices: number | null;
  inputType: V1CommonSurveySectionsGetOneTypePayloadInputTypeType;
  allowOther: boolean;
  allowText: boolean;
  displayOrder: number;
  isDynamic: boolean;
  isOptional: boolean;
  frequency: V1CommonSurveySectionsGetOneTypePayloadFrequencyType;
  useOptions: boolean;
  options: Array<V1CommonSurveyOptionsGetOneTypePayload>;
};

export const V1CommonSurveySectionsGetOneTypePayloadInputType = {
  TEXT: 'text',
  STRING: 'string',
  RADIO: 'radio',
  SELECT: 'select',
  PRIORITY_SELECT: 'priority_select',
  SCALE: 'scale',
  NPS: 'nps',
  SCALE_WITH_NOT_SELECTED: 'scale_with_not_selected',
};

export type V1CommonSurveySectionsGetOneTypePayloadInputTypeType =
  typeof V1CommonSurveySectionsGetOneTypePayloadInputType[keyof typeof V1CommonSurveySectionsGetOneTypePayloadInputType];

export const V1CommonSurveySectionsGetOneTypePayloadFrequency = {
  EVERYTIME: 'everytime',
  FIRST_ONLY: 'first_only',
  PARTIALLY_FIRST_ONLY: 'partially_first_only',
};

export type V1CommonSurveySectionsGetOneTypePayloadFrequencyType =
  typeof V1CommonSurveySectionsGetOneTypePayloadFrequency[keyof typeof V1CommonSurveySectionsGetOneTypePayloadFrequency];

/* Autogenerated from Payloads::V1::Common::SurveyOptions::GetOneType */
export type V1CommonSurveyOptionsGetOneTypePayload = {
  id: number;
  name: string;
  nextSectionId: number;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimeRequests::LatestRequestOneType */
export type V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayload =
  {
    regularMinutes: number;
    overtimeMinutes: number;
    nightMinutes: number;
    holidayMinutes: number;
    overtimeNightMinutes: number;
    holidayNightMinutes: number;
    totalOutsourcingMinutes: number;
    businessComment: string | null;
    respondedAt: string | null;
    createdAt: string;
    status: V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayloadStatusType;
  };

export const V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayloadStatus =
  {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
  };

export type V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayloadStatusType =
  typeof V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayloadStatus[keyof typeof V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayloadStatus];

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimeRequests::GetOneType */
export type V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayload = {
  regularMinutes: number;
  overtimeMinutes: number;
  nightMinutes: number;
  holidayMinutes: number;
  overtimeNightMinutes: number;
  holidayNightMinutes: number;
  totalOutsourcingMinutes: number;
  businessComment: string | null;
  status: V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayloadStatusType;
  sectionRequests: V1UsersiteParticipantWorkingTimeSectionRequestsGetManyTypePayload;
};

export const V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayloadStatus =
  {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
  };

export type V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayloadStatusType =
  typeof V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayloadStatus[keyof typeof V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayloadStatus];

/* Autogenerated from Payloads::V1::Usersite::InterestsUsers::IdManyType */
export type V1UsersiteInterestsUsersIdManyTypePayload = {
  interestIds: Array<number>;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::GetTopType */
export type V1UsersitePlansGetTopTypePayload = {
  id: number;
  title: string;
  isEmploymentEnabled: boolean;
  isAccepting: boolean;
  isFutureOpen: boolean;
  isFinished: boolean;
  isFavorite: boolean;
  isFollow: boolean;
  images: Array<V1UsersitePlanImagesGetOneTypePayload>;
  specificCategories: Array<V1UsersiteSpecificCategoriesGetOneTypePayload>;
  business: V1UsersiteBusinessesGetOnePlanTopTypePayload;
  terms: Array<V1UsersitePlanTermsGetOneTypePayload>;
  users: Array<V1UsersiteUsersGetOnePlanTypePayload>;
  userInfo: V1UsersitePlansUserInfoTypePayload;
  tip: V1CommonTipsGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::PlanImages::GetOneType */
export type V1UsersitePlanImagesGetOneTypePayload = {
  imageUrl: string;
  displayOrder: number | null;
};

/* Autogenerated from Payloads::V1::Usersite::SpecificCategories::GetOneType */
export type V1UsersiteSpecificCategoriesGetOneTypePayload = {
  name: string;
  color: string | null;
  kind: V1UsersiteSpecificCategoriesGetOneTypePayloadKindType;
};

export const V1UsersiteSpecificCategoriesGetOneTypePayloadKind = {
  NORMAL: 'normal',
  STRONG: 'strong',
};

export type V1UsersiteSpecificCategoriesGetOneTypePayloadKindType =
  typeof V1UsersiteSpecificCategoriesGetOneTypePayloadKind[keyof typeof V1UsersiteSpecificCategoriesGetOneTypePayloadKind];

/* Autogenerated from Payloads::V1::Usersite::PlanTerms::GetOneType */
export type V1UsersitePlanTermsGetOneTypePayload = {
  id: number;
  isAccepting: boolean;
  isFutureOpen: boolean;
  isFinished: boolean;
  termText: string;
  statusText: string;
  isMeetingShown: boolean;
  meetingPlace: string | null;
  meetingTime: string | null;
  meetingTimeText: string | null;
  isFreeMeeting: boolean;
  firstDayStatus: V1UsersitePlanTermsGetOneTypePayloadFirstDayStatusType;
  isDismissalShown: boolean;
  dismissalPlace: string | null;
  dismissalTime: string | null;
  dismissalTimeText: string | null;
  isFreeDismissal: boolean;
  lastDayStatus: V1UsersitePlanTermsGetOneTypePayloadLastDayStatusType;
  startDate: string;
  endDate: string;
  number: number;
  holidays: number;
  workingMinutesPerDay: number;
  totalWorkingMinutes: number;
  totalWorkingTimeText: string;
  workingDays: number;
  totalWages: number;
  workingNoticeUrl: string | null;
  workingTimes: Array<V1UsersitePlanTermWorkingTimesGetOneTypePayload>;
};

export const V1UsersitePlanTermsGetOneTypePayloadFirstDayStatus = {
  SCHEDULED: 'scheduled',
  MOVING: 'moving',
};

export type V1UsersitePlanTermsGetOneTypePayloadFirstDayStatusType =
  typeof V1UsersitePlanTermsGetOneTypePayloadFirstDayStatus[keyof typeof V1UsersitePlanTermsGetOneTypePayloadFirstDayStatus];

export const V1UsersitePlanTermsGetOneTypePayloadLastDayStatus = {
  SCHEDULED: 'scheduled',
  MOVING: 'moving',
};

export type V1UsersitePlanTermsGetOneTypePayloadLastDayStatusType =
  typeof V1UsersitePlanTermsGetOneTypePayloadLastDayStatus[keyof typeof V1UsersitePlanTermsGetOneTypePayloadLastDayStatus];

/* Autogenerated from Payloads::V1::Usersite::Plans::UserInfoType */
export type V1UsersitePlansUserInfoTypePayload = {
  canShowApplicationButton: boolean;
  inapplicableReason: string | null;
  applicableTerms: Array<V1UsersitePlanTermsApplicableOneTypePayload>;
  canShowFinalApprovalPage: boolean;
  canShowFinalApprovalButton: boolean;
  unableFinalApprovalReason: string | null;
  businessComment: string | null;
  displayRequestTermText: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::PlanTerms::ApplicableOneType */
export type V1UsersitePlanTermsApplicableOneTypePayload = {
  id: number;
  displayTerm: string;
  workingNoticeUrl: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::FacilityType */
export type V1UsersitePlansFacilityTypePayload = {
  id: number;
  kind: V1UsersitePlansFacilityTypePayloadKindType;
  roomType: V1UsersitePlansFacilityTypePayloadRoomTypeType;
  otherKind: string | null;
  otherRoomType: string | null;
  address: string | null;
  hotelName: string | null;
  hotelUrl: string | null;
  kindText: string;
  roomTypeText: string;
  hotelNameText: string | null;
  addressText: string | null;
  images: V1UsersitePlansFacilityImageManyTypePayload;
};

export const V1UsersitePlansFacilityTypePayloadKind = {
  GUEST_ROOM: 'guest_room',
  DORMITORY: 'dormitory',
  NEARBY_HOTEL: 'nearby_hotel',
  PRIVATE_HOUSE: 'private_house',
  OTHER_KIND: 'other_kind',
};

export type V1UsersitePlansFacilityTypePayloadKindType =
  typeof V1UsersitePlansFacilityTypePayloadKind[keyof typeof V1UsersitePlansFacilityTypePayloadKind];

export const V1UsersitePlansFacilityTypePayloadRoomType = {
  SINGLE: 'single',
  SHARED: 'shared',
  OTHER_ROOM_TYPE: 'other_room_type',
};

export type V1UsersitePlansFacilityTypePayloadRoomTypeType =
  typeof V1UsersitePlansFacilityTypePayloadRoomType[keyof typeof V1UsersitePlansFacilityTypePayloadRoomType];

/* Autogenerated from Payloads::V1::Usersite::Plans::GetMiddleType */
export type V1UsersitePlansGetMiddleTypePayload = {
  content: string;
  recruitmentBackground: string | null;
  benefit: string | null;
  belonging: string | null;
  notes: string | null;
  mealGrouping: V1UsersitePlansGetMiddleTypePayloadMealGroupingType;
  isAmenityUnavailable: boolean;
  isNearbyPlaceUnavailable: boolean;
  amenity: string | null;
  skillCategories: Array<V1UsersiteSkillCategoriesGetOneTypePayload>;
  meals: V1UsersitePlansMealManyTypePayload;
  facility: V1UsersitePlansFacilityTypePayload | null;
  accommodation: string | null;
  accommodationText: string | null;
  amenities: Array<V1UsersitePlansAmenityTypePayload> | null;
  amenitiesPlans: Array<V1UsersitePlansAmenitiesPlanTypePayload> | null;
  amenityDescription: string | null;
  nearbyPlacesPlans: Array<V1UsersitePlansNearbyPlacesPlanTypePayload> | null;
  nearbyPlaceDescription: string | null;
  atmosphereSliders: V1UsersitePlansAtmosphereSliderManyTypePayload;
};

export const V1UsersitePlansGetMiddleTypePayloadMealGrouping = {
  INDIVIDUAL: 'individual',
  ALL: 'all',
  MORNING_NOON: 'morning_noon',
  MORNING_EVENING: 'morning_evening',
  NOON_EVENING: 'noon_evening',
};

export type V1UsersitePlansGetMiddleTypePayloadMealGroupingType =
  typeof V1UsersitePlansGetMiddleTypePayloadMealGrouping[keyof typeof V1UsersitePlansGetMiddleTypePayloadMealGrouping];

/* Autogenerated from Payloads::V1::Usersite::SkillCategories::GetOneType */
export type V1UsersiteSkillCategoriesGetOneTypePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::AmenityType */
export type V1UsersitePlansAmenityTypePayload = {
  id: number;
  name: string;
  key: string;
  description: string;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::AmenitiesPlanType */
export type V1UsersitePlansAmenitiesPlanTypePayload = {
  isAvailable: boolean;
  amenity: V1UsersitePlansAmenityTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::NearbyPlacesPlanType */
export type V1UsersitePlansNearbyPlacesPlanTypePayload = {
  id: number | null;
  isAvailable: boolean;
  minutesOnFoot: number | null;
  nearbyPlace: V1UsersitePlansNearbyPlaceTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::NearbyPlaceType */
export type V1UsersitePlansNearbyPlaceTypePayload = {
  id: number;
  name: string;
  kind: string;
};

/* Autogenerated from Payloads::V1::Usersite::Plans::GetOnePaymentType */
export type V1UsersitePlansGetOnePaymentTypePayload = {
  id: number;
  title: string;
  thumbnailUrl: string;
  isEmploymentEnabled: boolean;
  isPublic: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::Applicants::CreateType */
export type V1UsersiteApplicantsCreateTypePayload = {
  id: number;
  acceptingTerms: Array<V1UsersitePlanTermsCreateApplicantOneTypePayload>;
  survey: V1CommonSurveysGetOneTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::PlanTerms::CreateApplicantOneType */
export type V1UsersitePlanTermsCreateApplicantOneTypePayload = {
  id: number;
  startDate: string;
  endDate: string;
  totalWages: number;
  workingNoticeUrl: string;
};

/* Autogenerated from Payloads::V1::Usersite::UserHometowns::GetType */
export type V1UsersiteUserHometownsGetTypePayload = {
  hometown: V1UsersiteUserHometownsGetOneTypePayload | null;
  regions: Array<V1CommonRegionsGetOneTypePayload>;
  countries: V1CommonCountriesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::UserHometowns::UpdateOneType */
export type V1UsersiteUserHometownsUpdateOneTypePayload = {
  hometown: V1UsersiteUserHometownsGetOneTypePayload | null;
  regions: Array<V1CommonRegionsGetOneTypePayload>;
  countries: V1CommonCountriesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::UserPlaces::BaseOneType */
export type V1UsersiteUserPlacesBaseOneTypePayload = {
  isOverseas: boolean;
  regionId: number | null;
  city: string | null;
  countryId: number | null;
  regionName: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::UserHometowns::GetOneType */
export type V1UsersiteUserHometownsGetOneTypePayload = {
  isOverseas: boolean;
  regionId: number | null;
  city: string | null;
  countryId: number | null;
  regionName: string | null;
  fullText: string;
};

/* Autogenerated from Payloads::V1::Usersite::UserResidences::UpdateOneType */
export type V1UsersiteUserResidencesUpdateOneTypePayload = {
  isOverseas: boolean;
  regionId: number | null;
  city: string | null;
  countryId: number | null;
  regionName: string | null;
  streetAddress: string | null;
  building: string | null;
  zip: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::UserResidences::GetOneType */
export type V1UsersiteUserResidencesGetOneTypePayload = {
  isOverseas: boolean;
  regionId: number | null;
  city: string | null;
  countryId: number | null;
  regionName: string | null;
  streetAddress: string | null;
  building: string | null;
  zip: string | null;
  fullText: string;
};

/* Autogenerated from Payloads::V1::Usersite::EmailAuths::AuthenticateType */
export type V1UsersiteEmailAuthsAuthenticateTypePayload = {
  isNewUser: boolean;
  firebaseCustomToken: string;
  signInProvider: V1UsersiteEmailAuthsAuthenticateTypePayloadSignInProviderType;
  user: V1UsersiteUsersAuthenticateTypePayload;
  authToken: V1UsersiteTokensAuthenticateTypePayload;
};

export const V1UsersiteEmailAuthsAuthenticateTypePayloadSignInProvider = {
  EMAIL: 'email',
};

export type V1UsersiteEmailAuthsAuthenticateTypePayloadSignInProviderType =
  typeof V1UsersiteEmailAuthsAuthenticateTypePayloadSignInProvider[keyof typeof V1UsersiteEmailAuthsAuthenticateTypePayloadSignInProvider];

/* Autogenerated from Payloads::V1::Usersite::Users::AuthenticateType */
export type V1UsersiteUsersAuthenticateTypePayload = {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  signInEmail: string | null;
  imageUrl: string | null;
  isRestricted: boolean;
  userTypeNames: Array<string>;
};

/* Autogenerated from Payloads::V1::Usersite::EmailAuths::UpdateType */
export type V1UsersiteEmailAuthsUpdateTypePayload = {
  messages: Array<string>;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantReviewSummaries::AtmosphereReviewType */
export type V1UsersiteParticipantReviewSummariesAtmosphereReviewTypePayload = {
  color: string;
  averageRating: number;
  portion: Array<V1UsersiteReviewOptionsAtmosphereReviewTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::ReviewOptions::AtmosphereReviewType */
export type V1UsersiteReviewOptionsAtmosphereReviewTypePayload = {
  portion: number;
  name: string;
  displayOrder: number;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantMonthlyWorkingTimes::GetOnePaymentType */
export type V1UsersiteParticipantMonthlyWorkingTimesGetOnePaymentTypePayload = {
  id: number;
  workedOn: string;
  regularMinutes: number;
  overtimeMinutes: number;
  nightMinutes: number;
  holidayMinutes: number;
  overtimeNightMinutes: number;
  holidayNightMinutes: number;
  totalMinutes: number;
  regularWage: number;
  overtimeWage: number;
  nightWage: number;
  holidayWage: number;
  overtimeNightWage: number;
  holidayNightWage: number;
  totalWage: number;
};

/* Autogenerated from Payloads::V1::Usersite::UserProfiles::GetType */
export type V1UsersiteUserProfilesGetTypePayload = {
  introduction: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::UserResidences::GetType */
export type V1UsersiteUserResidencesGetTypePayload = {
  residence: V1UsersiteUserResidencesGetOneTypePayload | null;
  regions: Array<V1CommonRegionsGetOneTypePayload>;
  countries: V1CommonCountriesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Experiences::GetType */
export type V1UsersiteExperiencesGetTypePayload = {
  noExperience: boolean;
  experiences: V1UsersiteExperiencesManyTypePayload;
};

/* Autogenerated from Payloads::V1::Common::Industries::GetOneType */
export type V1CommonIndustriesGetOneTypePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::V1::Usersite::ParticipantWorkingTimeSignatures::GetOneType */
export type V1UsersiteParticipantWorkingTimeSignaturesGetOneTypePayload = {
  imageUrl: string | null;
  picName: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneLessThanOrEqualToType */
export type V1UsersitePlanSearchConditionsGetOneLessThanOrEqualToTypePayload = {
  name: string;
  value: number;
};

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneCategoryType */
export type V1UsersitePlanSearchConditionsGetOneCategoryTypePayload = {
  name: string;
  value: string;
};

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneHowLongType */
export type V1UsersitePlanSearchConditionsGetOneHowLongTypePayload = {
  lessThanOrEqualTo: Array<V1UsersitePlanSearchConditionsGetOneLessThanOrEqualToTypePayload>;
  greaterThanOrEqualTo: Array<V1UsersitePlanSearchConditionsGetOneGreaterThanOrEqualToTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneGreaterThanOrEqualToType */
export type V1UsersitePlanSearchConditionsGetOneGreaterThanOrEqualToTypePayload =
  {
    name: string;
    value: number;
  };

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneType */
export type V1UsersitePlanSearchConditionsGetOneTypePayload = {
  regions: Array<V1CommonRegionsGetOneTypePayload>;
  categories: Array<V1UsersitePlanSearchConditionsGetOneCategoryTypePayload>;
  howLong: V1UsersitePlanSearchConditionsGetOneHowLongTypePayload;
  details: Array<V1UsersitePlanSearchConditionsGetOneDetailTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::PlanSearchConditions::GetOneDetailType */
export type V1UsersitePlanSearchConditionsGetOneDetailTypePayload = {
  name: string;
  value: number;
  paramName: string;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetSocialRouteTypeType */
export type V1UsersiteUsersGetSocialRouteTypeTypePayload = {
  name: string;
  value: V1UsersiteUsersGetSocialRouteTypeTypePayloadValueType;
};

export const V1UsersiteUsersGetSocialRouteTypeTypePayloadValue = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
};

export type V1UsersiteUsersGetSocialRouteTypeTypePayloadValueType =
  typeof V1UsersiteUsersGetSocialRouteTypeTypePayloadValue[keyof typeof V1UsersiteUsersGetSocialRouteTypeTypePayloadValue];

/* Autogenerated from Payloads::V1::Usersite::Users::GetSexType */
export type V1UsersiteUsersGetSexTypePayload = {
  name: string;
  value: V1UsersiteUsersGetSexTypePayloadValueType;
};

export const V1UsersiteUsersGetSexTypePayloadValue = {
  FEMALE: 'female',
  MALE: 'male',
  OTHER: 'other',
};

export type V1UsersiteUsersGetSexTypePayloadValueType =
  typeof V1UsersiteUsersGetSexTypePayloadValue[keyof typeof V1UsersiteUsersGetSexTypePayloadValue];

/* Autogenerated from Payloads::V1::Usersite::Users::GetInfoType */
export type V1UsersiteUsersGetInfoTypePayload = {
  user: V1UsersiteUsersInfoTypePayload;
  sexes: Array<V1UsersiteUsersGetSexTypePayload>;
  routeTypes: Array<V1UsersiteUsersGetRouteTypeTypePayload>;
  invitationRouteTypes: Array<V1UsersiteUsersGetInvitationRouteTypeTypePayload>;
  socialRouteTypes: Array<V1UsersiteUsersGetSocialRouteTypeTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Users::InfoType */
export type V1UsersiteUsersInfoTypePayload = {
  email: string | null;
  signInEmail: string | null;
  firstName: string | null;
  lastName: string | null;
  firstNameKana: string | null;
  lastNameKana: string | null;
  phoneNumber: string | null;
  phoneCountryCode: string | null;
  phoneVerifiedAt: string | null;
  dob: string | null;
  sex: V1UsersiteUsersInfoTypePayloadSexType | null;
  imageUrl: string | null;
  routeOfEntry: string | null;
  routeType: V1UsersiteUsersInfoTypePayloadRouteTypeType | null;
  invitationRouteType: V1UsersiteUsersInfoTypePayloadInvitationRouteTypeType | null;
  socialRouteType: V1UsersiteUsersInfoTypePayloadSocialRouteTypeType | null;
  providerType: V1UsersiteUsersInfoTypePayloadProviderTypeType | null;
  certificateType: V1UsersiteUsersInfoTypePayloadCertificateTypeType | null;
  certificateFrontUrl: string | null;
  certificateBackUrl: string | null;
  certificateUploadedAt: string | null;
  certificateStatus: V1UsersiteUsersInfoTypePayloadCertificateStatusType | null;
  certifiedAt: string | null;
  confirmedAt: string | null;
  confirmationSentAt: string | null;
  unconfirmedEmail: string | null;
  noEducation: boolean;
  noExperience: boolean;
  signInCount: number | null;
  lastSignInAt: string | null;
  hometown: V1UsersiteUserHometownsGetOneTypePayload | null;
  residence: V1UsersiteUserResidencesGetOneTypePayload | null;
};

export const V1UsersiteUsersInfoTypePayloadSex = {
  FEMALE: 'female',
  MALE: 'male',
  OTHER: 'other',
};

export type V1UsersiteUsersInfoTypePayloadSexType =
  typeof V1UsersiteUsersInfoTypePayloadSex[keyof typeof V1UsersiteUsersInfoTypePayloadSex];

export const V1UsersiteUsersInfoTypePayloadRouteType = {
  OTHER: 'other',
  INVITATION: 'invitation',
  SEARCH: 'search',
  MEDIA: 'media',
  EVENT: 'event',
  SNS: 'sns',
  TV: 'tv',
  RADIO: 'radio',
  NEWSPAPER: 'newspaper',
  WEB_ARTICLE: 'web_article',
  MUJIRUSHI_RYOHIN: 'mujirushi_ryohin',
};

export type V1UsersiteUsersInfoTypePayloadRouteTypeType =
  typeof V1UsersiteUsersInfoTypePayloadRouteType[keyof typeof V1UsersiteUsersInfoTypePayloadRouteType];

export const V1UsersiteUsersInfoTypePayloadInvitationRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
  DIRECTLY: 'directly',
};

export type V1UsersiteUsersInfoTypePayloadInvitationRouteTypeType =
  typeof V1UsersiteUsersInfoTypePayloadInvitationRouteType[keyof typeof V1UsersiteUsersInfoTypePayloadInvitationRouteType];

export const V1UsersiteUsersInfoTypePayloadSocialRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
};

export type V1UsersiteUsersInfoTypePayloadSocialRouteTypeType =
  typeof V1UsersiteUsersInfoTypePayloadSocialRouteType[keyof typeof V1UsersiteUsersInfoTypePayloadSocialRouteType];

export const V1UsersiteUsersInfoTypePayloadProviderType = {
  NONE: 'none',
  EMAIL: 'email',
  GOOGLE_OAUTH2: 'google_oauth2',
  FACEBOOK: 'facebook',
  LINE: 'line',
  ONE: 'one',
  APPLE: 'apple',
};

export type V1UsersiteUsersInfoTypePayloadProviderTypeType =
  typeof V1UsersiteUsersInfoTypePayloadProviderType[keyof typeof V1UsersiteUsersInfoTypePayloadProviderType];

export const V1UsersiteUsersInfoTypePayloadCertificateType = {
  DRIVER_LICENSE: 'driver_license',
  PASSPORT: 'passport',
  MY_NUMBER: 'my_number',
  RESIDENCE_CARD: 'residence_card',
};

export type V1UsersiteUsersInfoTypePayloadCertificateTypeType =
  typeof V1UsersiteUsersInfoTypePayloadCertificateType[keyof typeof V1UsersiteUsersInfoTypePayloadCertificateType];

export const V1UsersiteUsersInfoTypePayloadCertificateStatus = {
  UNCERTIFIED: 'uncertified',
  CONFIRMING: 'confirming',
  CERTIFIED: 'certified',
  REJECTED: 'rejected',
};

export type V1UsersiteUsersInfoTypePayloadCertificateStatusType =
  typeof V1UsersiteUsersInfoTypePayloadCertificateStatus[keyof typeof V1UsersiteUsersInfoTypePayloadCertificateStatus];

/* Autogenerated from Payloads::V1::Usersite::Users::UpdateInfoType */
export type V1UsersiteUsersUpdateInfoTypePayload = {
  email: string | null;
  signInEmail: string | null;
  firstName: string | null;
  lastName: string | null;
  firstNameKana: string | null;
  lastNameKana: string | null;
  phoneNumber: string | null;
  phoneCountryCode: string | null;
  phoneVerifiedAt: string | null;
  dob: string | null;
  sex: V1UsersiteUsersUpdateInfoTypePayloadSexType | null;
  imageUrl: string | null;
  routeOfEntry: string | null;
  routeType: V1UsersiteUsersUpdateInfoTypePayloadRouteTypeType | null;
  invitationRouteType: V1UsersiteUsersUpdateInfoTypePayloadInvitationRouteTypeType | null;
  socialRouteType: V1UsersiteUsersUpdateInfoTypePayloadSocialRouteTypeType | null;
  providerType: V1UsersiteUsersUpdateInfoTypePayloadProviderTypeType | null;
  certificateType: V1UsersiteUsersUpdateInfoTypePayloadCertificateTypeType | null;
  certificateFrontUrl: string | null;
  certificateBackUrl: string | null;
  certificateUploadedAt: string | null;
  certificateStatus: V1UsersiteUsersUpdateInfoTypePayloadCertificateStatusType | null;
  certifiedAt: string | null;
  confirmedAt: string | null;
  confirmationSentAt: string | null;
  unconfirmedEmail: string | null;
  noEducation: boolean;
  noExperience: boolean;
  signInCount: number | null;
  lastSignInAt: string | null;
  hometown: V1UsersiteUserHometownsGetOneTypePayload | null;
  residence: V1UsersiteUserResidencesGetOneTypePayload | null;
};

export const V1UsersiteUsersUpdateInfoTypePayloadSex = {
  FEMALE: 'female',
  MALE: 'male',
  OTHER: 'other',
};

export type V1UsersiteUsersUpdateInfoTypePayloadSexType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadSex[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadSex];

export const V1UsersiteUsersUpdateInfoTypePayloadRouteType = {
  OTHER: 'other',
  INVITATION: 'invitation',
  SEARCH: 'search',
  MEDIA: 'media',
  EVENT: 'event',
  SNS: 'sns',
  TV: 'tv',
  RADIO: 'radio',
  NEWSPAPER: 'newspaper',
  WEB_ARTICLE: 'web_article',
  MUJIRUSHI_RYOHIN: 'mujirushi_ryohin',
};

export type V1UsersiteUsersUpdateInfoTypePayloadRouteTypeType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadRouteType[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadRouteType];

export const V1UsersiteUsersUpdateInfoTypePayloadInvitationRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
  DIRECTLY: 'directly',
};

export type V1UsersiteUsersUpdateInfoTypePayloadInvitationRouteTypeType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadInvitationRouteType[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadInvitationRouteType];

export const V1UsersiteUsersUpdateInfoTypePayloadSocialRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
};

export type V1UsersiteUsersUpdateInfoTypePayloadSocialRouteTypeType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadSocialRouteType[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadSocialRouteType];

export const V1UsersiteUsersUpdateInfoTypePayloadProviderType = {
  NONE: 'none',
  EMAIL: 'email',
  GOOGLE_OAUTH2: 'google_oauth2',
  FACEBOOK: 'facebook',
  LINE: 'line',
  ONE: 'one',
  APPLE: 'apple',
};

export type V1UsersiteUsersUpdateInfoTypePayloadProviderTypeType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadProviderType[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadProviderType];

export const V1UsersiteUsersUpdateInfoTypePayloadCertificateType = {
  DRIVER_LICENSE: 'driver_license',
  PASSPORT: 'passport',
  MY_NUMBER: 'my_number',
  RESIDENCE_CARD: 'residence_card',
};

export type V1UsersiteUsersUpdateInfoTypePayloadCertificateTypeType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadCertificateType[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadCertificateType];

export const V1UsersiteUsersUpdateInfoTypePayloadCertificateStatus = {
  UNCERTIFIED: 'uncertified',
  CONFIRMING: 'confirming',
  CERTIFIED: 'certified',
  REJECTED: 'rejected',
};

export type V1UsersiteUsersUpdateInfoTypePayloadCertificateStatusType =
  typeof V1UsersiteUsersUpdateInfoTypePayloadCertificateStatus[keyof typeof V1UsersiteUsersUpdateInfoTypePayloadCertificateStatus];

/* Autogenerated from Payloads::V1::Usersite::Users::GetRouteTypeType */
export type V1UsersiteUsersGetRouteTypeTypePayload = {
  name: string;
  value: V1UsersiteUsersGetRouteTypeTypePayloadValueType;
  inputType: V1UsersiteUsersGetRouteTypeTypePayloadInputTypeType;
};

export const V1UsersiteUsersGetRouteTypeTypePayloadValue = {
  OTHER: 'other',
  INVITATION: 'invitation',
  SEARCH: 'search',
  MEDIA: 'media',
  EVENT: 'event',
  SNS: 'sns',
  TV: 'tv',
  RADIO: 'radio',
  NEWSPAPER: 'newspaper',
  WEB_ARTICLE: 'web_article',
  MUJIRUSHI_RYOHIN: 'mujirushi_ryohin',
};

export type V1UsersiteUsersGetRouteTypeTypePayloadValueType =
  typeof V1UsersiteUsersGetRouteTypeTypePayloadValue[keyof typeof V1UsersiteUsersGetRouteTypeTypePayloadValue];

export const V1UsersiteUsersGetRouteTypeTypePayloadInputType = {
  TEXT: 'text',
  SELECT: 'select',
};

export type V1UsersiteUsersGetRouteTypeTypePayloadInputTypeType =
  typeof V1UsersiteUsersGetRouteTypeTypePayloadInputType[keyof typeof V1UsersiteUsersGetRouteTypeTypePayloadInputType];

/* Autogenerated from Payloads::V1::Usersite::Users::GetInvitationRouteTypeType */
export type V1UsersiteUsersGetInvitationRouteTypeTypePayload = {
  name: string;
  value: V1UsersiteUsersGetInvitationRouteTypeTypePayloadValueType;
};

export const V1UsersiteUsersGetInvitationRouteTypeTypePayloadValue = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
  DIRECTLY: 'directly',
};

export type V1UsersiteUsersGetInvitationRouteTypeTypePayloadValueType =
  typeof V1UsersiteUsersGetInvitationRouteTypeTypePayloadValue[keyof typeof V1UsersiteUsersGetInvitationRouteTypeTypePayloadValue];

/* Autogenerated from Payloads::V1::Usersite::Users::GetUserPaymentType */
export type V1UsersiteUsersGetUserPaymentTypePayload = {
  bankAccount: V1UsersiteUsersGetUserBankAccountTypePayload | null;
  thisMonthPayment: V1UsersiteUsersGetPaymentTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetUserBankAccountType */
export type V1UsersiteUsersGetUserBankAccountTypePayload = {
  accountNumber: string;
  accountName: string;
  bankCode: string | null;
  bankName: string | null;
  branchCode: string | null;
  branchName: string | null;
  imageUrl: string;
  accountType: V1UsersiteUsersGetUserBankAccountTypePayloadAccountTypeType;
  dataType: V1UsersiteUsersGetUserBankAccountTypePayloadDataTypeType;
  bank: V1CommonBanksGetTypePayload | null;
  branch: V1CommonBankBranchesGetTypePayload | null;
};

export const V1UsersiteUsersGetUserBankAccountTypePayloadAccountType = {
  ORDINARY: 'ordinary',
  CURRENT: 'current',
};

export type V1UsersiteUsersGetUserBankAccountTypePayloadAccountTypeType =
  typeof V1UsersiteUsersGetUserBankAccountTypePayloadAccountType[keyof typeof V1UsersiteUsersGetUserBankAccountTypePayloadAccountType];

export const V1UsersiteUsersGetUserBankAccountTypePayloadDataType = {
  ASSOCIATION: 'association',
  TEXT: 'text',
};

export type V1UsersiteUsersGetUserBankAccountTypePayloadDataTypeType =
  typeof V1UsersiteUsersGetUserBankAccountTypePayloadDataType[keyof typeof V1UsersiteUsersGetUserBankAccountTypePayloadDataType];

/* Autogenerated from Payloads::V1::Common::Banks::GetType */
export type V1CommonBanksGetTypePayload = {
  id: number;
  code: string;
  hira: string;
  kana: string;
  name: string;
  roma: string;
};

/* Autogenerated from Payloads::V1::Common::BankBranches::GetType */
export type V1CommonBankBranchesGetTypePayload = {
  id: number;
  code: string;
  hira: string;
  kana: string;
  name: string;
  roma: string;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetPaymentType */
export type V1UsersiteUsersGetPaymentTypePayload = {
  amount: number;
  paidOn: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::Users::UpdatePhoneType */
export type V1UsersiteUsersUpdatePhoneTypePayload = {
  phoneNumber: string;
  phoneCountryCode: string;
  phoneVerifiedAt: string;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetMessageChannelType */
export type V1UsersiteUsersGetMessageChannelTypePayload = {
  name: string;
  value: V1UsersiteUsersGetMessageChannelTypePayloadValueType;
};

export const V1UsersiteUsersGetMessageChannelTypePayloadValue = {
  MAIL: 'mail',
  LINE: 'line',
};

export type V1UsersiteUsersGetMessageChannelTypePayloadValueType =
  typeof V1UsersiteUsersGetMessageChannelTypePayloadValue[keyof typeof V1UsersiteUsersGetMessageChannelTypePayloadValue];

/* Autogenerated from Payloads::V1::Usersite::Users::NoEducationType */
export type V1UsersiteUsersNoEducationTypePayload = {
  noEducation: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetTutorialType */
export type V1UsersiteUsersGetTutorialTypePayload = {
  firstName: string | null;
  lastName: string | null;
  firstNameKana: string | null;
  lastNameKana: string | null;
  email: string | null;
  sex: string | null;
  dob: string | null;
  routeType: V1UsersiteUsersGetTutorialTypePayloadRouteTypeType | null;
  routeOfEntry: string | null;
  socialRouteType: V1UsersiteUsersGetTutorialTypePayloadSocialRouteTypeType | null;
  invitationRouteType: V1UsersiteUsersGetTutorialTypePayloadInvitationRouteTypeType | null;
};

export const V1UsersiteUsersGetTutorialTypePayloadRouteType = {
  OTHER: 'other',
  INVITATION: 'invitation',
  SEARCH: 'search',
  MEDIA: 'media',
  EVENT: 'event',
  SNS: 'sns',
  TV: 'tv',
  RADIO: 'radio',
  NEWSPAPER: 'newspaper',
  WEB_ARTICLE: 'web_article',
  MUJIRUSHI_RYOHIN: 'mujirushi_ryohin',
};

export type V1UsersiteUsersGetTutorialTypePayloadRouteTypeType =
  typeof V1UsersiteUsersGetTutorialTypePayloadRouteType[keyof typeof V1UsersiteUsersGetTutorialTypePayloadRouteType];

export const V1UsersiteUsersGetTutorialTypePayloadSocialRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
};

export type V1UsersiteUsersGetTutorialTypePayloadSocialRouteTypeType =
  typeof V1UsersiteUsersGetTutorialTypePayloadSocialRouteType[keyof typeof V1UsersiteUsersGetTutorialTypePayloadSocialRouteType];

export const V1UsersiteUsersGetTutorialTypePayloadInvitationRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
  DIRECTLY: 'directly',
};

export type V1UsersiteUsersGetTutorialTypePayloadInvitationRouteTypeType =
  typeof V1UsersiteUsersGetTutorialTypePayloadInvitationRouteType[keyof typeof V1UsersiteUsersGetTutorialTypePayloadInvitationRouteType];

/* Autogenerated from Payloads::V1::Usersite::Users::GetProfileType */
export type V1UsersiteUsersGetProfileTypePayload = {
  noExperience: boolean;
  noEducation: boolean;
  profile: V1UsersiteUserProfilesGetTypePayload;
  allergies: Array<V1CommonAllergiesGetOneWithOtherTypePayload>;
  characteristics: Array<V1CommonCharacteristicsGetOneTypePayload>;
  educations: Array<V1UsersiteEducationsGetOneTypePayload>;
  experiences: Array<V1UsersiteExperiencesGetOneTypePayload>;
  expressions: Array<V1UsersiteUserExpressionsGetOneTypePayload>;
  hobbies: Array<V1CommonHobbiesGetOneWithOtherTypePayload>;
  interests: Array<V1CommonInterestsGetOneWithOtherTypePayload>;
  qualifications: Array<V1CommonQualificationsGetOneWithOtherTypePayload>;
  schedules: Array<V1UsersiteUserSchedulesOneTypePayload>;
  skills: Array<V1CommonPersonalSkillsGetOneWithOtherTypePayload>;
  thisMonthPayment: V1UsersiteUsersGetPaymentTypePayload;
};

/* Autogenerated from Payloads::V1::Common::Allergies::GetOneType */
export type V1CommonAllergiesGetOneTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Allergies::GetOneWithOtherType */
export type V1CommonAllergiesGetOneWithOtherTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
  usersAllergyId: number;
  other: string | null;
};

/* Autogenerated from Payloads::V1::Common::Characteristics::GetOneType */
export type V1CommonCharacteristicsGetOneTypePayload = {
  id: number;
  name: string;
};

/* Autogenerated from Payloads::V1::Common::Hobbies::GetOneType */
export type V1CommonHobbiesGetOneTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Hobbies::GetOneWithOtherType */
export type V1CommonHobbiesGetOneWithOtherTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
  other: string | null;
};

/* Autogenerated from Payloads::V1::Common::Interests::GetOneType */
export type V1CommonInterestsGetOneTypePayload = {
  id: number;
  name: string;
  division: number;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Interests::GetOneWithOtherType */
export type V1CommonInterestsGetOneWithOtherTypePayload = {
  id: number;
  name: string;
  division: number;
  isOther: boolean;
  other: string | null;
};

/* Autogenerated from Payloads::V1::Common::Qualifications::TertiaryOneType */
export type V1CommonQualificationsTertiaryOneTypePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Qualifications::GetOneWithOtherType */
export type V1CommonQualificationsGetOneWithOtherTypePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
  userQualificationId: number;
  other: string;
};

/* Autogenerated from Payloads::V1::Usersite::UserSchedules::OneType */
export type V1UsersiteUserSchedulesOneTypePayload = {
  id: number;
  date: string;
};

/* Autogenerated from Payloads::V1::Common::PersonalSkills::GetOneType */
export type V1CommonPersonalSkillsGetOneTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::PersonalSkills::GetOneWithOtherType */
export type V1CommonPersonalSkillsGetOneWithOtherTypePayload = {
  id: number;
  name: string;
  isOther: boolean;
  other: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::Users::GetFollowingBusinessIdsType */
export type V1UsersiteUsersGetFollowingBusinessIdsTypePayload = {
  followingBusinessIds: Array<number>;
};

/* Autogenerated from Payloads::V1::Usersite::Users::NoExperienceType */
export type V1UsersiteUsersNoExperienceTypePayload = {
  noExperience: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::UserPayments::GetOneHistoryType */
export type V1UsersiteUserPaymentsGetOneHistoryTypePayload = {
  payment: V1UsersiteUserPaymentsGetOneTypePayload;
  participant: V1UsersiteParticipantsGetOnePaymentTypePayload;
  business: V1UsersiteBusinessesGetOnePaymentTypePayload;
  plan: V1UsersitePlansGetOnePaymentTypePayload;
  planTerm: V1UsersitePlanTermsGetOnePaymentTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::UserPayments::GetOneType */
export type V1UsersiteUserPaymentsGetOneTypePayload = {
  amount: number;
  paidOn: string;
  monthlyWorkingTime: V1UsersiteParticipantMonthlyWorkingTimesGetOnePaymentTypePayload | null;
  details: Array<V1UsersiteUserPaymentDetailsGetOnePaymentTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::UserPaymentDetails::GetOnePaymentType */
export type V1UsersiteUserPaymentDetailsGetOnePaymentTypePayload = {
  name: string;
  amount: number;
};

/* Autogenerated from Payloads::V1::Usersite::PlanTerms::GetOnePaymentType */
export type V1UsersitePlanTermsGetOnePaymentTypePayload = {
  id: number;
  startDate: string;
  endDate: string;
};

/* Autogenerated from Payloads::V1::Usersite::UserPayments::GetManyHistoriesType */
export type V1UsersiteUserPaymentsGetManyHistoriesTypePayload = {
  page: number;
  hasMore: boolean;
  results: Array<V1UsersiteUserPaymentsGetOneHistoryTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::FollowingBusinesses::GetManyType */
export type V1UsersiteFollowingBusinessesGetManyTypePayload = {
  businesses: Array<V1UsersiteBusinessesGetOneTypePayload>;
  page: number;
  hasMore: boolean;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::UpdateFifthType */
export type V1UsersiteTutorialsUpdateFifthTypePayload = {
  message: string;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::GetThirdType */
export type V1UsersiteTutorialsGetThirdTypePayload = {
  user: V1UsersiteTutorialsRegionTypePayload;
  regions: Array<V1CommonRegionsGetOneTypePayload>;
  countries: V1CommonCountriesGetManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::RegionType */
export type V1UsersiteTutorialsRegionTypePayload = {
  residence: V1UsersiteTutorialsResidenceTypePayload | null;
  interestedRegions: Array<V1UsersiteTutorialsInterestedRegionTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::ResidenceType */
export type V1UsersiteTutorialsResidenceTypePayload = {
  isOverseas: boolean;
  regionId: number | null;
  city: string | null;
  countryId: number | null;
  regionName: string | null;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::InterestedRegionType */
export type V1UsersiteTutorialsInterestedRegionTypePayload = {
  regionId: number;
  priority: number;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::UpdateFourthType */
export type V1UsersiteTutorialsUpdateFourthTypePayload = {
  interestIds: Array<number>;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::UpdateThirdType */
export type V1UsersiteTutorialsUpdateThirdTypePayload = {
  residence: V1UsersiteTutorialsResidenceTypePayload;
  interestedRegions: Array<V1UsersiteTutorialsInterestedRegionTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::SkipType */
export type V1UsersiteTutorialsSkipTypePayload = {
  message: string;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::GetFifthType */
export type V1UsersiteTutorialsGetFifthTypePayload = {
  businesses: Array<V1UsersiteBusinessesGetOneTypePayload>;
  user: V1UsersiteUsersGetFollowingBusinessIdsTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::GetSecondType */
export type V1UsersiteTutorialsGetSecondTypePayload = {
  user: V1UsersiteUsersGetTutorialTypePayload;
  routeTypes: Array<V1UsersiteUsersGetRouteTypeTypePayload>;
  invitationRouteTypes: Array<V1UsersiteUsersGetInvitationRouteTypeTypePayload>;
  socialRouteTypes: Array<V1UsersiteUsersGetSocialRouteTypeTypePayload>;
  sexes: Array<V1UsersiteUsersGetSexTypePayload>;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::ResumeNumberType */
export type V1UsersiteTutorialsResumeNumberTypePayload = {
  resumeNumber: number | null;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::GetFourthType */
export type V1UsersiteTutorialsGetFourthTypePayload = {
  interests: V1CommonInterestsGetManyTypePayload;
  user: V1UsersiteInterestsUsersIdManyTypePayload;
};

/* Autogenerated from Payloads::V1::Usersite::Tutorials::UpdateSecondType */
export type V1UsersiteTutorialsUpdateSecondTypePayload = {
  firstName: string;
  lastName: string;
  firstNameKana: string;
  lastNameKana: string;
  email: string;
  sex: string;
  dob: string;
  routeType: V1UsersiteTutorialsUpdateSecondTypePayloadRouteTypeType;
  routeOfEntry: string | null;
  socialRouteType: V1UsersiteTutorialsUpdateSecondTypePayloadSocialRouteTypeType | null;
  invitationRouteType: V1UsersiteTutorialsUpdateSecondTypePayloadInvitationRouteTypeType | null;
};

export const V1UsersiteTutorialsUpdateSecondTypePayloadRouteType = {
  OTHER: 'other',
  INVITATION: 'invitation',
  SEARCH: 'search',
  MEDIA: 'media',
  EVENT: 'event',
  SNS: 'sns',
  TV: 'tv',
  RADIO: 'radio',
  NEWSPAPER: 'newspaper',
  WEB_ARTICLE: 'web_article',
  MUJIRUSHI_RYOHIN: 'mujirushi_ryohin',
};

export type V1UsersiteTutorialsUpdateSecondTypePayloadRouteTypeType =
  typeof V1UsersiteTutorialsUpdateSecondTypePayloadRouteType[keyof typeof V1UsersiteTutorialsUpdateSecondTypePayloadRouteType];

export const V1UsersiteTutorialsUpdateSecondTypePayloadSocialRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
};

export type V1UsersiteTutorialsUpdateSecondTypePayloadSocialRouteTypeType =
  typeof V1UsersiteTutorialsUpdateSecondTypePayloadSocialRouteType[keyof typeof V1UsersiteTutorialsUpdateSecondTypePayloadSocialRouteType];

export const V1UsersiteTutorialsUpdateSecondTypePayloadInvitationRouteType = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NOTE: 'note',
  DIRECTLY: 'directly',
};

export type V1UsersiteTutorialsUpdateSecondTypePayloadInvitationRouteTypeType =
  typeof V1UsersiteTutorialsUpdateSecondTypePayloadInvitationRouteType[keyof typeof V1UsersiteTutorialsUpdateSecondTypePayloadInvitationRouteType];

/* Autogenerated from Payloads::V1::Usersite::ParticipantDailyWorkingTimes::GetOneType */
export type V1UsersiteParticipantDailyWorkingTimesGetOneTypePayload = {
  id: number;
  workedOn: string;
  isHoliday: boolean;
  regularMinutes: number;
  overtimeMinutes: number;
  nightMinutes: number;
  holidayMinutes: number;
  overtimeNightMinutes: number;
  holidayNightMinutes: number;
  totalOutsourcingMinutes: number;
  availableSections: V1UsersiteParticipantWorkingTimeSectionsGetManyTypePayload;
  displaySections: V1UsersiteParticipantWorkingTimeSectionsGetManyTypePayload;
  latestRequest: V1UsersiteParticipantDailyWorkingTimeRequestsLatestRequestOneTypePayload | null;
  pendingRequest: V1UsersiteParticipantDailyWorkingTimeRequestsGetOneTypePayload | null;
};

/* Autogenerated from Payloads::V1::Usersite::Socials::AuthenticateType */
export type V1UsersiteSocialsAuthenticateTypePayload = {
  uid: string;
  isNewUser: boolean;
  firebaseCustomToken: string;
  signInProvider: V1UsersiteSocialsAuthenticateTypePayloadSignInProviderType;
  user: V1UsersiteUsersAuthenticateTypePayload;
  authToken: V1UsersiteTokensAuthenticateTypePayload;
};

export const V1UsersiteSocialsAuthenticateTypePayloadSignInProvider = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
  LINE: 'line',
  ONE_ODAKYU: 'one_odakyu',
  FIREBASE: 'firebase',
  APPLE: 'apple',
};

export type V1UsersiteSocialsAuthenticateTypePayloadSignInProviderType =
  typeof V1UsersiteSocialsAuthenticateTypePayloadSignInProvider[keyof typeof V1UsersiteSocialsAuthenticateTypePayloadSignInProvider];

/* Autogenerated from Payloads::V1::Usersite::Socials::GetFirebaseCustomTokenType */
export type V1UsersiteSocialsGetFirebaseCustomTokenTypePayload = {
  firebaseCustomToken: string;
};

/* Autogenerated from Payloads::V1::Usersite::Educations::GetType */
export type V1UsersiteEducationsGetTypePayload = {
  noEducation: boolean;
  educations: V1UsersiteEducationsManyTypePayload;
};

/* Autogenerated from Payloads::V1::Common::ReviewSections::GetOneType */
export type V1CommonReviewSectionsGetOneTypePayload = {
  id: number;
  kind: V1CommonReviewSectionsGetOneTypePayloadKindType;
  name: string;
  description: string;
  inputType: V1CommonReviewSectionsGetOneTypePayloadInputTypeType;
  allowRating: boolean;
  allowOther: boolean;
  allowComment: boolean;
  displayOrder: number;
  isRequired: boolean;
  color: string;
  ratingStatus: V1CommonReviewSectionsGetOneTypePayloadRatingStatusType;
  answerStatus: V1CommonReviewSectionsGetOneTypePayloadAnswerStatusType;
  commentStatus: V1CommonReviewSectionsGetOneTypePayloadCommentStatusType;
  options: Array<V1CommonReviewOptionsGetOneTypePayload>;
};

export const V1CommonReviewSectionsGetOneTypePayloadKind = {
  ATMOSPHERE: 'atmosphere',
  PLAN_CONTENT: 'plan_content',
  BENEFIT_CHARM: 'benefit_charm',
  PERSONALITY: 'personality',
  ATTITUDE: 'attitude',
};

export type V1CommonReviewSectionsGetOneTypePayloadKindType =
  typeof V1CommonReviewSectionsGetOneTypePayloadKind[keyof typeof V1CommonReviewSectionsGetOneTypePayloadKind];

export const V1CommonReviewSectionsGetOneTypePayloadInputType = {
  SELECT: 'select',
  SELECT_WITH_REASON: 'select_with_reason',
  TEXT: 'text',
  RATING: 'rating',
};

export type V1CommonReviewSectionsGetOneTypePayloadInputTypeType =
  typeof V1CommonReviewSectionsGetOneTypePayloadInputType[keyof typeof V1CommonReviewSectionsGetOneTypePayloadInputType];

export const V1CommonReviewSectionsGetOneTypePayloadRatingStatus = {
  BUSINESS: 'business',
  PRIMARY: 'primary',
};

export type V1CommonReviewSectionsGetOneTypePayloadRatingStatusType =
  typeof V1CommonReviewSectionsGetOneTypePayloadRatingStatus[keyof typeof V1CommonReviewSectionsGetOneTypePayloadRatingStatus];

export const V1CommonReviewSectionsGetOneTypePayloadAnswerStatus = {
  BUSINESS: 'business',
  PRIMARY: 'primary',
};

export type V1CommonReviewSectionsGetOneTypePayloadAnswerStatusType =
  typeof V1CommonReviewSectionsGetOneTypePayloadAnswerStatus[keyof typeof V1CommonReviewSectionsGetOneTypePayloadAnswerStatus];

export const V1CommonReviewSectionsGetOneTypePayloadCommentStatus = {
  BUSINESS: 'business',
  PRIMARY: 'primary',
};

export type V1CommonReviewSectionsGetOneTypePayloadCommentStatusType =
  typeof V1CommonReviewSectionsGetOneTypePayloadCommentStatus[keyof typeof V1CommonReviewSectionsGetOneTypePayloadCommentStatus];

/* Autogenerated from Payloads::V1::Common::ReviewOptions::GetOneType */
export type V1CommonReviewOptionsGetOneTypePayload = {
  id: number;
  name: string;
  displayOrder: number;
  maxRating: number;
  minRating: number;
};

/* Autogenerated from Payloads::V1::Common::Areas::GetOneType */
export type V1CommonAreasGetOneTypePayload = {
  id: number;
  name: string;
  enName: string;
};

/* Autogenerated from Payloads::V1::Common::Allergies::GetOnePrimaryType */
export type V1CommonAllergiesGetOnePrimaryTypePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
  tertiaryItems: Array<V1CommonAllergiesGetOneTertiaryTypePayload>;
};

/* Autogenerated from Payloads::V1::Common::Allergies::GetOneTertiaryType */
export type V1CommonAllergiesGetOneTertiaryTypePayload = {
  id: number;
  name: string;
  itemType: string;
  isOther: boolean;
};

/* Autogenerated from Payloads::V1::Common::Reviews::GetOneType */
export type V1CommonReviewsGetOneTypePayload = {
  id: number;
  title: string;
  description: string;
  sections: Array<V1CommonReviewSectionsGetOneTypePayload>;
};

/* Autogenerated from Inputs::V1::Admins::PlanAtmosphereSliders::UpdateType */
export type V1AdminsPlanAtmosphereSlidersUpdateTypeInput = {
  value: string;
  destroy: boolean;
  kind: V1AdminsPlanAtmosphereSlidersUpdateTypeInputKindType;
};

export const V1AdminsPlanAtmosphereSlidersUpdateTypeInputKind = {
  EXPECTATION: 'expectation',
  POWER_JOB: 'power_job',
  STAFF_HOMETOWN: 'staff_hometown',
  RELATIONSHIP_NO_BUSINESS: 'relationship_no_business',
  AGE_GROUP: 'age_group',
  CONDITION: 'condition',
  NATURE: 'nature',
  HOTEL: 'hotel',
  RELATIONSHIP_BUSINESS: 'relationship_business',
  GENDER: 'gender',
};

export type V1AdminsPlanAtmosphereSlidersUpdateTypeInputKindType =
  typeof V1AdminsPlanAtmosphereSlidersUpdateTypeInputKind[keyof typeof V1AdminsPlanAtmosphereSlidersUpdateTypeInputKind];

/* Autogenerated from Inputs::V1::Usersite::Businesses::GetType */
export type V1UsersiteBusinessesGetTypeInput = {
  regionIds?: string;
  feature?: string;
  page: number;
};

/* Autogenerated from Inputs::V1::Usersite::Businesses::DestroyFollowType */
export type V1UsersiteBusinessesDestroyFollowTypeInput = {
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::Businesses::UpdateFollowType */
export type V1UsersiteBusinessesUpdateFollowTypeInput = {
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::InterestsUsers::UpdateManyType */
export type V1UsersiteInterestsUsersUpdateManyTypeInput = {
  interestsUsers: Array<V1UsersiteInterestsUsersUpdateOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Usersite::InterestsUsers::UpdateOneType */
export type V1UsersiteInterestsUsersUpdateOneTypeInput = {
  interestId: number;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::Plans::GetTopType */
export type V1UsersitePlansGetTopTypeInput = {
  id: number;
  applicantId?: number;
};

/* Autogenerated from Inputs::V1::Usersite::HobbiesUsers::OneType */
export type V1UsersiteHobbiesUsersOneTypeInput = {
  hobbyId: number;
  destroy?: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::HobbiesUsers::UpdateType */
export type V1UsersiteHobbiesUsersUpdateTypeInput = {
  hobbiesUsers: Array<V1UsersiteHobbiesUsersOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Usersite::Applicants::CancelType */
export type V1UsersiteApplicantsCancelTypeInput = {
  userReason: string;
};

/* Autogenerated from Inputs::V1::Usersite::Applicants::RejectType */
export type V1UsersiteApplicantsRejectTypeInput = {
  userReason: string;
};

/* Autogenerated from Inputs::V1::Usersite::Applicants::CreateType */
export type V1UsersiteApplicantsCreateTypeInput = {
  termId: number;
  memo: string;
  motive: string | null;
  follow: boolean;
  isAgreedWorkingNotice: boolean;
  isInterviewAccepted: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::UserPlaces::BaseOneType */
export type V1UsersiteUserPlacesBaseOneTypeInput = {
  isOverseas: boolean;
  regionId?: number;
  city?: string;
  countryId?: number;
  regionName?: string;
};

/* Autogenerated from Inputs::V1::Usersite::UserHometowns::UpdateOneType */
export type V1UsersiteUserHometownsUpdateOneTypeInput = {
  isOverseas: boolean;
  regionId?: number;
  city?: string;
  countryId?: number;
  regionName?: string;
};

/* Autogenerated from Inputs::V1::Usersite::UserResidences::UpdateOneType */
export type V1UsersiteUserResidencesUpdateOneTypeInput = {
  isOverseas: boolean;
  regionId?: number;
  city?: string;
  countryId?: number;
  regionName?: string;
  streetAddress: string | null;
  building: string | null;
  zip: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::Users::TutorialResidenceType */
export type V1UsersiteUsersTutorialResidenceTypeInput = {
  isOverseas: boolean;
  regionId?: number;
  city?: string;
  countryId?: number;
  regionName?: string;
};

/* Autogenerated from Inputs::V1::Usersite::EmailAuths::SignInType */
export type V1UsersiteEmailAuthsSignInTypeInput = {
  signInEmail: string;
  password: string;
};

/* Autogenerated from Inputs::V1::Usersite::EmailAuths::CreateAccountType */
export type V1UsersiteEmailAuthsCreateAccountTypeInput = {
  signInEmail: string;
  password: string;
};

/* Autogenerated from Inputs::V1::Usersite::EmailAuths::UpdateType */
export type V1UsersiteEmailAuthsUpdateTypeInput = {
  signInEmail?: string | null;
  currentPassword?: string | null;
  password?: string | null;
  passwordConfirmation?: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::UserProfiles::UpdateType */
export type V1UsersiteUserProfilesUpdateTypeInput = {
  introduction: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::Experiences::BaseOneType */
export type V1UsersiteExperiencesBaseOneTypeInput = {
  organization: string;
  role: string;
  startDate: string;
  endDate?: string | null;
  description: string;
  industryId: number;
};

/* Autogenerated from Inputs::V1::Usersite::Experiences::UpdateOneType */
export type V1UsersiteExperiencesUpdateOneTypeInput = {
  organization: string;
  role: string;
  startDate: string;
  endDate?: string | null;
  description: string;
  industryId: number;
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::Experiences::CreateOneType */
export type V1UsersiteExperiencesCreateOneTypeInput = {
  organization: string;
  role: string;
  startDate: string;
  endDate?: string | null;
  description: string;
  industryId: number;
};

/* Autogenerated from Inputs::V1::Usersite::Experiences::DeleteOneType */
export type V1UsersiteExperiencesDeleteOneTypeInput = {
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::Users::InterestIdsType */
export type V1UsersiteUsersInterestIdsTypeInput = {
  interestIds: Array<number>;
};

/* Autogenerated from Inputs::V1::Usersite::Users::UpdatePhoneType */
export type V1UsersiteUsersUpdatePhoneTypeInput = {
  token: string;
  countryCode: string;
};

/* Autogenerated from Inputs::V1::Usersite::Users::NoEducationType */
export type V1UsersiteUsersNoEducationTypeInput = {
  noEducation: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::Users::InterestedRegionType */
export type V1UsersiteUsersInterestedRegionTypeInput = {
  regionId: number;
  priority: number;
};

/* Autogenerated from Inputs::V1::Usersite::Users::UserBankAccountType */
export type V1UsersiteUsersUserBankAccountTypeInput = {
  accountNumber: string;
  accountName: string;
  bankId: number | null;
  branchId: number | null;
  bankName: string | null;
  bankCode: string | null;
  branchName: string | null;
  branchCode: string | null;
  imageBlob: string | null;
  accountType: V1UsersiteUsersUserBankAccountTypeInputAccountTypeType;
  dataType: V1UsersiteUsersUserBankAccountTypeInputDataTypeType;
};

export const V1UsersiteUsersUserBankAccountTypeInputAccountType = {
  ORDINARY: 'ordinary',
  CURRENT: 'current',
};

export type V1UsersiteUsersUserBankAccountTypeInputAccountTypeType =
  typeof V1UsersiteUsersUserBankAccountTypeInputAccountType[keyof typeof V1UsersiteUsersUserBankAccountTypeInputAccountType];

export const V1UsersiteUsersUserBankAccountTypeInputDataType = {
  ASSOCIATION: 'association',
  TEXT: 'text',
};

export type V1UsersiteUsersUserBankAccountTypeInputDataTypeType =
  typeof V1UsersiteUsersUserBankAccountTypeInputDataType[keyof typeof V1UsersiteUsersUserBankAccountTypeInputDataType];

/* Autogenerated from Inputs::V1::Usersite::Users::NoExperienceType */
export type V1UsersiteUsersNoExperienceTypeInput = {
  noExperience: boolean;
};

/* Autogenerated from Inputs::V1::Usersite::Users::UpdateInfoType */
export type V1UsersiteUsersUpdateInfoTypeInput = {
  email?: string;
  firstName?: string;
  lastName?: string;
  firstNameKana?: string;
  lastNameKana?: string;
  dob?: string;
  sex?: V1UsersiteUsersUpdateInfoTypeInputSexType;
  imageBlob?: string;
  certificateType?: V1UsersiteUsersUpdateInfoTypeInputCertificateTypeType;
  certificateFrontBlob?: string;
  certificateBackBlob?: string;
};

export const V1UsersiteUsersUpdateInfoTypeInputSex = {
  FEMALE: 'female',
  MALE: 'male',
  OTHER: 'other',
};

export type V1UsersiteUsersUpdateInfoTypeInputSexType =
  typeof V1UsersiteUsersUpdateInfoTypeInputSex[keyof typeof V1UsersiteUsersUpdateInfoTypeInputSex];

export const V1UsersiteUsersUpdateInfoTypeInputCertificateType = {
  DRIVER_LICENSE: 'driver_license',
  PASSPORT: 'passport',
  MY_NUMBER: 'my_number',
  RESIDENCE_CARD: 'residence_card',
};

export type V1UsersiteUsersUpdateInfoTypeInputCertificateTypeType =
  typeof V1UsersiteUsersUpdateInfoTypeInputCertificateType[keyof typeof V1UsersiteUsersUpdateInfoTypeInputCertificateType];

/* Autogenerated from Inputs::V1::Usersite::Tips::CreateType */
export type V1UsersiteTipsCreateTypeInput = {
  kind: V1UsersiteTipsCreateTypeInputKindType;
};

export const V1UsersiteTipsCreateTypeInputKind = {
  ROOM_STICKER: 'room_sticker',
  BUSINESS_FOLLOW: 'business_follow',
  FIRST_BUSINESS_PAGE_PUBLISH: 'first_business_page_publish',
  ADMIN_FIRST_LOGIN: 'admin_first_login',
};

export type V1UsersiteTipsCreateTypeInputKindType =
  typeof V1UsersiteTipsCreateTypeInputKind[keyof typeof V1UsersiteTipsCreateTypeInputKind];

/* Autogenerated from Inputs::V1::Usersite::Surveys::ParticipantAfterFinishedType */
export type V1UsersiteSurveysParticipantAfterFinishedTypeInput = {
  participantId: number;
};

/* Autogenerated from Inputs::V1::Usersite::Tutorials::UpdateThirdType */
export type V1UsersiteTutorialsUpdateThirdTypeInput = {
  residence: V1UsersiteUsersTutorialResidenceTypeInput;
  interestedRegions: Array<V1UsersiteUsersInterestedRegionTypeInput>;
};

/* Autogenerated from Inputs::V1::Usersite::Tutorials::SkipType */
export type V1UsersiteTutorialsSkipTypeInput = {
  number: number;
};

/* Autogenerated from Inputs::V1::Usersite::Tutorials::UpdateSecondType */
export type V1UsersiteTutorialsUpdateSecondTypeInput = {
  firstName: string;
  lastName: string;
  firstNameKana: string;
  lastNameKana: string;
  email: string;
  sex: string;
  dob: string;
  routeType: string;
  routeOfEntry: string | null;
  socialRouteType: string | null;
  invitationRouteType: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::CreateCheckinType */
export type V1UsersiteParticipantDailyWorkingTimesCreateCheckinTypeInput = {
  latitude: string | null;
  longitude: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::RejectType */
export type V1UsersiteParticipantDailyWorkingTimesRejectTypeInput = {
  participantComment: string;
  workedOn: string;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::CreateCheckoutType */
export type V1UsersiteParticipantDailyWorkingTimesCreateCheckoutTypeInput = {
  latitude: string | null;
  longitude: string | null;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::CreateType */
export type V1UsersiteParticipantDailyWorkingTimesCreateTypeInput = {
  imageBlob?: string;
  picName?: string;
  dailyWorkingTimes: V1UsersiteParticipantDailyWorkingTimesManyTypeInput;
};

/* Autogenerated from Inputs::V1::Usersite::ParticipantDailyWorkingTimes::ApproveType */
export type V1UsersiteParticipantDailyWorkingTimesApproveTypeInput = {
  participantComment?: string;
  workedOn: string;
};

/* Autogenerated from Inputs::V1::Usersite::Socials::OneType */
export type V1UsersiteSocialsOneTypeInput = {
  idToken: string;
};

/* Autogenerated from Inputs::V1::Usersite::Socials::LineType */
export type V1UsersiteSocialsLineTypeInput = {
  idToken: string;
};

/* Autogenerated from Inputs::V1::Usersite::Socials::AppleType */
export type V1UsersiteSocialsAppleTypeInput = {
  firebaseIdToken?: string;
  idToken?: string;
};

/* Autogenerated from Inputs::V1::Usersite::Socials::GoogleType */
export type V1UsersiteSocialsGoogleTypeInput = {
  firebaseIdToken?: string;
  accessToken?: string;
};

/* Autogenerated from Inputs::V1::Usersite::Socials::FacebookType */
export type V1UsersiteSocialsFacebookTypeInput = {
  firebaseIdToken?: string;
  accessToken?: string;
};

/* Autogenerated from Inputs::V1::Usersite::WithholdingSlips::GetType */
export type V1UsersiteWithholdingSlipsGetTypeInput = {
  page: number;
};

/* Autogenerated from Inputs::V1::Usersite::Educations::BaseOneType */
export type V1UsersiteEducationsBaseOneTypeInput = {
  school: string;
  degree?: string | null;
  faculty: string;
  department?: string | null;
  startDate: string;
  endDate?: string | null;
  description: string;
};

/* Autogenerated from Inputs::V1::Usersite::Educations::UpdateOneType */
export type V1UsersiteEducationsUpdateOneTypeInput = {
  school: string;
  degree?: string | null;
  faculty: string;
  department?: string | null;
  startDate: string;
  endDate?: string | null;
  description: string;
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::Educations::CreateOneType */
export type V1UsersiteEducationsCreateOneTypeInput = {
  school: string;
  degree?: string | null;
  faculty: string;
  department?: string | null;
  startDate: string;
  endDate?: string | null;
  description: string;
};

/* Autogenerated from Inputs::V1::Usersite::Educations::DestroyOneType */
export type V1UsersiteEducationsDestroyOneTypeInput = {
  id: number;
};

/* Autogenerated from Inputs::V1::Usersite::PasswordResets::VerificationType */
export type V1UsersitePasswordResetsVerificationTypeInput = {
  token: string;
};

/* Autogenerated from Inputs::V1::Common::ParticipantReviewSections::CreateOneType */
export type V1CommonParticipantReviewSectionsCreateOneTypeInput = {
  sectionId: number;
  comment: string;
  other: string;
  rating: number;
  options?: Array<V1CommonParticipantReviewOptionsCreateOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Common::ParticipantReviewOptions::CreateOneType */
export type V1CommonParticipantReviewOptionsCreateOneTypeInput = {
  optionId: number;
  rating: number;
};

/* Autogenerated from Inputs::V1::Common::ParticipantReviews::CreateOneType */
export type V1CommonParticipantReviewsCreateOneTypeInput = {
  message: string;
  rating: number;
  sections: Array<V1CommonParticipantReviewSectionsCreateOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Common::SurveyResponseSections::CreateOneType */
export type V1CommonSurveyResponseSectionsCreateOneTypeInput = {
  sectionId: number;
  answer?: string | null;
  otherAnswer?: string | null;
  reason?: string | null;
  rating?: number | null;
  options?: Array<V1CommonSurveyResponseOptionsCreateOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Common::SurveyResponseOptions::CreateOneType */
export type V1CommonSurveyResponseOptionsCreateOneTypeInput = {
  optionId: number;
  priority?: number | null;
};

/* Autogenerated from Inputs::V1::Common::SurveyResponses::CreateOneType */
export type V1CommonSurveyResponsesCreateOneTypeInput = {
  surveyId: number | null;
  sections: Array<V1CommonSurveyResponseSectionsCreateOneTypeInput>;
};

/* Autogenerated from Inputs::V1::Common::Banks::GetType */
export type V1CommonBanksGetTypeInput = {
  name?: string | null;
};
